<template>
    <!--    <Header chose_index="2"></Header>-->
    <div style="width:100%;height:20px;"></div>
    <article class="home_page_container" id="scrollable" @scroll="handleScroll($event)">
        <div style="width: 100%;height: 40px;line-height: 40px;padding: 20px 20px 0 20px;">
            <span style="font-size: 16px;font-weight:bold;">志愿表信息</span>
        </div>
        <div
            style="font-family: 'Microsoft YaHei';padding: 0 20px;display: flex;justify-content: space-between;align-items: center;position: relative;">
            <div style="height: 50px;line-height: 50px;">
                <span>{{ examinees_application_info.name }}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                分数: {{ examinees_application_info.score }}
                位次: {{ examinees_application_info.precedence }}
                科目: {{ examinees_application_info.subjects }}
            </div>
            <div
                style="display: flex;justify-content: left;align-content: center;position:absolute;top:-10px;right:10px;">
                <div style="height: 60px;line-height: 60px;margin-left: 10px;">
                    高冲:{{ gao_chong }} 冲:{{ impulse }} 稳:{{ stability }} 保:{{ guarantee }} 低保:{{ di_bao }}
                </div>
            </div>
        </div>
        <div style="width: 100%;height:20px;background-color: #F5F4F8"></div>
        <div>
            <div style="padding: 20px;" v-if="report_list.length > 0">
                <div>
                    <div style="font-size: 16px;font-weight:bold;margin-bottom: 15px;">我的报告</div>
                    <el-form label-width="120px" :inline="true">
                        <el-form-item label-width="50px" v-for="report_info in report_list">
                            <i class="el-icon-s-order" style="color: #c30000;font-size: 20px;"></i>
                            {{ report_info.create_str }}
                            <span style="margin-left: 15px;" size="small">{{ report_info.status_str }}</span>
                            <div style="display: inline-block" v-if="report_info.status == 2">
                                <el-button v-if="report_info.pdf_url.length > 0"
                                           style="margin-left: 20px;background-color: #E93A29;color: #FFFFFF;border: 0;"
                                           size="mini" @click="look_report(report_info.pdf_url)">
                                    查看
                                </el-button>
                                <el-button v-else
                                           style="margin-left: 20px;background-color: #E93A29;color: #FFFFFF;border: 0;"
                                           size="mini"
                                           @click="open_report(report_info.id)">
                                    查看
                                </el-button>
                                <el-button type="info"
                                           size="mini"
                                           style="display:none;"
                                           @click="remove_report(report_info.id)">
                                    删除
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div style="width: 100%;height:20px;background-color: #F5F4F8" v-if="report_list.length > 0"></div>
            <div class="zhiyuanList" style="padding: 20px;" v-loading="loading">
                <article>
                    <div id="top_con">
                        <div style="height:5px;"></div>
                        <div class="chose_box">
                            <div class="tabbar">
                                <div :class="tab === index ? 'onbar' : 'bar'" v-for="(item,index) in tabData"
                                     :key="index"
                                     @click="changeTab(index)">
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                        
                        <div style="height: 60px;line-height: 60px;display: flex;justify-content:right;align-items:center;">
                            <div class="plan_sort" :style="chose_rank === 'score'?'color:#e93a29':''" @click="collection_rank('score')">
                                <el-icon>
                                    <Sort/>
                                </el-icon>
                                <div>分数排序</div>
                            </div>
                            <el-popover
                                placement="top-start"
                                title=""
                                :width="200"
                                trigger="hover"
                                content="价值排序是综合参考了志愿的院校层次、院校性质、专业实力等因素进行的综合排序！"
                            >
                                <template #reference>
                                    <div class="plan_sort" :style="chose_rank === 'tuijian'?'color:#e93a29;':''" @click="chose_value_rank">
                                        <el-icon>
                                            <Sort/>
                                        </el-icon>
                                        <div style="display:flex;">
                                            <div>价值排序</div>
                                            <div v-if="teacher_login">(当前分段区间:{{ value_rank }}分)</div>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                            <div class="plan_sort" :style="chose_rank === 'diqu'?'color:#e93a29':''" @click="collection_rank('diqu')">
                                <el-icon>
                                    <Sort/>
                                </el-icon>
                                <div>地域排序</div>
                            </div>
                            <div class="plan_sort" :style="chose_rank === 'xyh'?'color:#e93a29':''" @click="collection_rank('xyh')">
                                <el-icon>
                                    <Sort/>
                                </el-icon>
                                <div>校友会</div>
                            </div>
                            <div class="plan_sort" :style="chose_rank === 'ruanke'?'color:#e93a29':''" @click="collection_rank('ruanke')">
                                <el-icon>
                                    <Sort/>
                                </el-icon>
                                <div>软科</div>
                            </div>
                            <div class="plan_sort" :style="chose_rank === 'qs'?'color:#e93a29':''" @click="collection_rank('qs')">
                                <el-icon>
                                    <Sort/>
                                </el-icon>
                                <div>QS</div>
                            </div>
                            <el-button size="mini" type="warning" @click="save_favorites($event, false)">保存</el-button>
                            <el-button size="mini" v-if="can_change_plans" type="warning" @click="mod_favorites">修改</el-button>
                            <el-button size="mini" v-else @click="canot_change_favorites">修改</el-button>
                            <el-button size="mini" type="warning" @click="download_collection_demo">下载收藏列表</el-button>
                            <div id="submit_report_view"
                                 style="display: flex;justify-content: center;align-items: center;">
                                <div style="margin-left: 10px;margin-right: 20px;"
                                     v-if="(examinees_application_info.batch_pre === 'ben' || examinees_application_info.batch_pre === 'zhuan') && user_power.submit_report == 1">
                                    <el-button
                                        v-if="base_info.submit_times > 0"
                                        size="mini"
                                        style="background-color: #E93A29;color: #FFFFFF;border: 0;"
                                        @click="check_submit"
                                    >
                                        提交审核(剩余次数:{{ base_info.submit_times }})
                                    </el-button>
                                    <el-button
                                        v-else
                                        size="mini"
                                        style="background-color: #E93A29;color: #FFFFFF;border: 0;"
                                        @click="buy_submit_times"
                                    >
                                        开通志愿审核
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="tab === 0" id="sortable_list">
                        <div style="width: 100%;text-align: center;" v-if="tableData.length < 1">
                            <el-button type="primary"
                                       style="width: 200px;background-color: #E93A29;color: #FFFFFF;border:#E93A29;">
                                {{ tableData_str }}
                            </el-button>
                        </div>
                        <div>
                            <div v-if="batch_model === 'major_class'">
                                <ClassPlanList
                                    :plans="tableData"
                                    :select_rank="select_rank"
                                    :favorite_value="1"
                                    :user_power="user_power"
                                    :province_score_gailv="province_score_gailv"
                                    :province_score_chongwenbao="province_score_chongwenbao"
                                    :system_tips_list="system_tips_list"
                                    @show_majors_job="show_majors_job"
                                    @un_favorite="un_favorite"
                                    @rank_change="rank_change"
                                    @favorite="favorite"
                                    @no_match_major="no_match_major"
                                    @school_info="school_info"
                                    @school_map="school_map"
                                >
                                </ClassPlanList>
                            </div>
                            <div v-else-if="batch_model === 'major_group'">
                                <GroupPlanList
                                    :plans="tableData"
                                    :sub_plans="sub_favorite_list"
                                    :select_rank="select_rank"
                                    :sub_select_rank="sub_select_rank"
                                    :collect_list="favorite_list"
                                    :favorite_value="1"
                                    :user_power="user_power"
                                    :province_score_gailv="province_score_gailv"
                                    :province_score_chongwenbao="province_score_chongwenbao"
                                    :search_type="form.search_type"
                                    :batch_pre="this.batch_pre"
                                    :system_tips_list="system_tips_list"
                                    @sub_plans_list="sub_plans_list"
                                    @show_majors_job="show_majors_job"
                                    @un_favorite="un_favorite"
                                    @rank_change="rank_change"
                                    @favorite="favorite"
                                    @no_match_major="no_match_major"
                                    @school_info="school_info"
                                    @school_map="school_map"
                                >
                                </GroupPlanList>
                            </div>
                            <div v-else-if="batch_model === 'school_strategy'">
                                <SchoolPlanList
                                    :plans="tableData"
                                    :select_rank="select_rank"
                                    :sub_select_rank="sub_select_rank"
                                    :favorite_value="1"
                                    :collect_list="favorite_list"
                                    :user_power="user_power"
                                    :province_score_gailv="province_score_gailv"
                                    :province_score_chongwenbao="province_score_chongwenbao"
                                    :sub_plans="sub_favorite_list"
                                    :search_type="form.search_type"
                                    :batch_pre="this.batch_pre"
                                    :system_tips_list="system_tips_list"
                                    @rank_change="rank_change"
                                    @sub_plans_list="sub_plans_list"
                                    @show_majors_job="show_majors_job"
                                    @un_favorite="un_favorite"
                                    @favorite="favorite"
                                    @change="change"
                                    @no_match_major="no_match_major"
                                    @school_info="school_info"
                                    @school_map="school_map"
                                >
                                </SchoolPlanList>
                            </div>
                        </div>
                    </div>
                    <div v-show="tab === 1">
                        <div v-show="batch_model === 'major_class'">
                            <ClassDrag :favorite_list="favorite_list" @rank_change="rank_change"
                                       @un_favorite="un_favorite"></ClassDrag>
                        </div>
                        <div v-show="batch_model !== 'major_class'">
                            <SchoolGroupDrag :batch_model="batch_model" :favorite_list="favorite_list"
                                             @sub_plans_list="sub_plans_list"
                                             @show_detail="show_detail" @rank_change="rank_change"
                                             @un_favorite="un_favorite"></SchoolGroupDrag>
                        </div>
                    </div>
                    <div style="margin-top: 20px;"></div>
                </article>
            </div>
        </div>
    </article>
    <el-dialog
        v-model="remove_report_status"
        title="提醒"
        width="30%"
        :before-close="reportHandleClose"
    >
        <span>您确定删除该报告？</span>
        <template #footer>
      <span class="dialog-footer">
        <el-button @click="cannel_remove_report">取消</el-button>
        <el-button type="primary" @click="confirm_remove_report">确定</el-button>
      </span>
        </template>
    </el-dialog>
    <el-dialog v-model="upload_collection_status" title="导入收藏志愿" :width="1000"
               :before-close="errorCollectionHandleClose">
        <el-table border stripe height="500" :data="upload_collection_list">
            <el-table-column property="school_name" label="学校名称"/>
            <el-table-column property="school_code" label="学校code" width="100"/>
            <el-table-column property="majors" label="专业名称"/>
            <el-table-column property="major_num" label="专业code" width="100"/>
            <el-table-column property="result_str" label="结果" width="100"/>
            <el-table-column property="result_str" label="结果" width="120">
                <template #default="scope">
                    <el-button
                        v-if="scope.row.result != 1 "
                        type="danger"
                        size="small"
                    >
                        {{ scope.row.result_str }}
                    </el-button>
                    <el-button
                        v-else
                        type="success"
                        size="small"
                    >
                        {{ scope.row.result_str }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="upload_collection_status = false">关闭</el-button>
                <el-button type="primary" @click="download_error_collection">导出错误数据</el-button>
            </span>
        </template>
    </el-dialog>
    <BackTop></BackTop>
    <input
        type="file"
        id="file"
        name="file"
        @change="upload_file"
        style="display: none"
    />
    <el-dialog v-model="show_submit_status" title="提醒" width="30%" :before-close="handleClose">
        <span>确认提交审核志愿?</span>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="show_submit_status = false">取消</el-button>
            <el-button type="primary" @click="submit_report_fun()">
              确定
            </el-button>
            </span>
        </template>
    </el-dialog>
    <el-dialog v-model="show_buy_submit_status" title="提醒" width="30%">
        <span>您的志愿审核次数已不足5次</span>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="buy_submit_times">购买志愿审核次数</el-button>
            <el-button type="primary" @click="submit_report_fun()">
              继续提交审核
            </el-button>
            </span>
        </template>
    </el-dialog>
    <el-dialog
        v-model="show_majors_job_info"
        title="就业方向"
        width="60%"
        :before-close="majors_job_info_close">
        <div style="overflow-y: scroll;max-height: 600px;">
            <div v-if="majors_job_info === null || majors_job_info.length < 1">暂无数据</div>
            <div v-else-if="majors_job_list.length < 1">加载中...</div>
            <div v-else>
                <div v-for="item in majors_job_info">
                    <div style="font-size: 18px;font-weight: bold;color:#f56c6c;">
                        {{ item.name }}
                        <span style="margin-left: 20px;font-size:14px;cursor: pointer;color:#333333;"
                              @click="show_major_detail(item.name, item.code)">点击查看详情>></span>
                    </div>
                    <div style="margin-bottom: 10px;" v-if="majors_job_list[item.code] !== undefined">
                        <span style="margin-right: 10px;color:#666666;"
                              v-html="majors_job_list[item.code]['job_orientation']"></span>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button size="small" type="primary" @click="majors_job_info_close">关闭</el-button>
          </span>
        </template>
    </el-dialog>
    <Dragball :gailv="gailv"></Dragball>
</template>

<script>
import http from '@/utils/http'
import env from '@/utils/env'
import XLSX from "xlsx"
import api from '@/api'
import axios from 'axios'
import Header from '@/components/Header.vue'
import EditInfo from "../components/EditInfo";
import AddMoreInfo from "../components/AddMoreInfo";
import EditPassword from "../components/EditPassword";
import logo from '@/assets/logo.png';
import zhi from '@/assets/zhi.png';
import yuan from '@/assets/yuan.png';
import {ElNotification, ElMessageBox, ElMessage, ElLoading} from 'element-plus'
import "@/assets/css/iconfont.css"
import {CollectionTag, Finished, Search} from "@element-plus/icons";
import SchoolPlanList from "@/components/SchoolPlanList.vue";
import ClassPlanList from "@/components/ClassPlanList.vue";
import GroupPlanList from "@/components/GroupPlanList.vue";
import BackTop from "@/components/BackTop.vue";
import Footer from "@/components/Footer.vue";
import XLSX_JS from "xlsx-js-style";
import Dragball from "@/components/DragBall.vue";
import ClassDrag from "@/components/ClassDrag.vue";
import SchoolGroupDrag from "@/components/SchoolGroupDrag.vue";

import {driver} from "driver.js";
import "@/assets/css/driver.css";

export default {
    name: 'HomePage',
    computed: {
        Search() {
            return Search
        }
    },
    components: {
        SchoolGroupDrag,
        ClassDrag,
        Dragball,
        Footer,
        GroupPlanList, ClassPlanList, SchoolPlanList,
        CollectionTag,
        Finished,
        AddMoreInfo,
        EditInfo,
        Header,
        EditPassword,
        BackTop
    },
    data() {
        return {
            loading: true,
            value_rank: 5,
            tab: 0,
            chose_rank: '',
            tabData: ['志愿列表(详表)', '志愿列表(简表)'],
            url: env[process.env.NODE_ENV].JSON_SITE,
            batch_id: 0,
            show_report_popover: false,
            show_submit_status: false,
            show_buy_submit_status: false,
            application_form_id: 0,
            remove_report_status: false,
            show_user_agreement: false,
            remind_status: false,
            rank_status: false,
            collection_total: 0,
            remove_report_id: 0,
            vocation_collection_total: 0,
            art_collection_total: 0,
            pre_collection_total: 0,
            logo: logo,
            timer: null,
            favorites_status: false,
            favorites_index: 0,
            favorites_list: [],
            favorites_type: 1,
            show_edit_info: 0,
            marks: [],
            upload_collection_list: [],
            collection_type: 'collection_undergraduate',
            favorite_list: [],
            sub_favorite_list: [],
            dialogFormVisible: true,
            provinces: [],
            types: [],
            schools: [],
            serial_number: ['', '', '', ''],
            major_one: [],
            major_two: [],
            major_three: [],
            major_three_list: [],
            majorse: [],
            school_list: [],
            level: [],
            plans: {},
            tableData: [],
            plan_ids: [],
            plan_key: [],
            favorite_plan_list: [],
            subTableData: [],
            allSubTableData: [],
            subTableDataRank: [],
            tableData_str: '加载中...',
            before_one: '',
            before_two: '',
            before_three: '',
            vip_level: 0,
            modify_score_times: 0,
            detailed_info_times: 0,
            collect_sort_type: false,
            show_history_year: [],
            system_tips_list: {
                1: {name: '等效分'},
                2: {name: '上段位变化量'},
                3: {name: '本校招生变化量'},
                4: {name: ''},
                5: {name: '位次'}
            },
            system_tips_1_name: '',
            system_tips_2_name: '',
            system_tips_3_name: '',
            captcha: '',
            phone: '',
            zhi: zhi,
            yuan: yuan,
            show_more_info: 0,
            show_pass_info: 0,
            active: 1,
            edit_info: false,
            approval_id: 0,
            chage_rank: 0,
            show_recommend_rank: 0,
            recommend_ranking: true,
            user_is_register: false,
            show_get_phone_code: true,
            branch: [
                {
                    'name': '',
                    'class_name': '',
                    'score_line': '',
                    'level': ''
                }
            ],
            base_info: {
                'class_id': 0,
                'score': 0,
                'name': '',
                'province': '0',
                'province_id': '0',
                'subject_one': 0,
                'subject_three': 0,
                'subject_two': 0,
                'subjects': "",
                'year': "",
                'majors': [],
                'vip_60_need_card': 1,
                'vip_experience_times': 0,
                'vip_level': 0,
                'is_vip': 0,
                'can_be_modified': 0,
                'expires_in': '',
                'open_experience_vip': 1
            },
            group_name: '',
            group_id: 0,
            level_name: '',
            batch_model: '',
            form: {
                provinces: [],
                type: [],
                educational_type: [],
                level: [],
                school_level: [],
                recruit_type: [],
                nature_type: [],
                school_ids: [],
                follow_major: [],
                major_one: 0,
                level_one: 0,
                major_two: [],
                level_two: [],
                page_size: 10,
                total: 0,
                page: 1,
                show_more: 1,
                search_type: 1,
                score_range: 2,
            },
            approval: [],
            submit_times: 0,
            approval_num: 0,
            approval_info: {
                approve_num: 0,
                instructor_id: 0,
                instructor_name: "",
                instructor_nickname: "",
                num: 0,
                times: 0,
            },
            approval_list: [],
            subjects_name: [],
            report_info: {
                'id': 0, 'member_name': '', 'member_score': '', 'member_subjects': '', 'num': '',
                'json_url': '', 'pdf_url': '', 'status': 0, 'created_at': '', 'create_str': '',
                'status_str': '',
            },
            report_num: -1,
            report_list: [],
            agreement: '',
            batch_pre: '',
            show_agreement: 1,
            need_more_info: 0,
            user_status: 0,
            vocation_api: env[process.env.NODE_ENV].VOCATION_API,
            arts_api: env[process.env.NODE_ENV].ART_API,
            preb_api: env[process.env.NODE_ENV].PRE_API,
            show_majors_job_info: false,
            majors_job_info: [],
            majors_job_list: [],
            show_major_label: 0,
            submit_report: 0,
            show_value_rank: 0,
            upload_collection_batch: 5,
            upload_collection_status: false,
            upload_collection_type: 2,
            examinees_application_info: {
                batch_id: 0,
                created_at: "0",
                examinees_report_id: 0,
                id: 2,
                member_id: 0,
                name: "",
                num: 0,
                precedence: "0",
                batch_name: "",
                score: "0",
                status: 1,
                subjects: "",
                type: 5,
                updated_at: "",
            },
            oss_sheng_list: [],
            un_favorite_list: [],
            plan_info: {
                "collection": 1,
                "foreign_study_mode": "",
                "foreign_universities": "",
                "foreign_rules": "",
                "province_id": 0,
                "province_name": "",
                "major_group_code": "",
                "school_pre": "",
                "batch_name": "",
                "school_guarantee_rate": "",
                "double_first_class_level": "",
                "majors": "",
                "majors_name": "",
                "majors_list": [],
                "majors_count": 0,
                "new_major": 0,
                "major_remind_desc": [],
                "school_id": 0,
                "school_logo": "",
                "school_name": "",
                "address": "",
                "school_code": "",
                "major_num": "",
                "nature_str": "",
                "nation_feature": "",
                "postgraduate_str": "",
                "type_str": "",
                "district_info": 0,
                "school_topic_info": 0,
                "major_topic_info": 0,
                "score_topic": 0,
                "diff": "",
                "use_sum": "",
                "forecast_low_score": 0,
                "forecast_match_precedence": 0,
                "discipline_ranking_major_str": "",
                "postgraduate_major_str": "",
                "doctor_major_str": "",
                "first_class_major_str": "",
                "label_list": [],
                "num": 0,
                "length": 0,
                "fees": "0",
                "major_group_rule": "",
                "historical_data": {},
                "xuanke_rule": {},
                "remarks": "",
                "majors_remarks": "",
                "postgraduate": 0,
            },
            select_rank: [],
            sub_select_rank: [],
            oss_list_url: [],
            user_power: {'submit_report': 1, 'show_major_label': 1, 'show_value_rank': 1},
            province_score_gailv: [],
            province_score_toudang_gailv: [],
            province_score_chongwenbao: [],
            batch_type: '',
            //冲稳保个数
            guarantee: 0,
            gao_chong: 0,
            di_bao: 0,
            impulse: 0,
            stability: 0,
            // 冲稳保概率
            gailv: 0,
            all_gailv: 0,
            gc_gailv: 0,
            c_gailv: 0,
            w_gailv: 0,
            b_gailv: 0,
            db_gailv: 0,
            gc_all_gailv: 0,
            c_all_gailv: 0,
            w_all_gailv: 0,
            b_all_gailv: 0,
            db_all_gailv: 0,
            gc_num: 0,
            c_num: 0,
            w_num: 0,
            b_num: 0,
            db_num: 0,
            
            load_more: false,
            can_change_plans: true,
            teacher_login: false
            // 冲稳保概率
        }
    },
    mounted() {
        window.scrollTo(0, 0); // 滚动到顶部
    },
    updated() {
        // //console.log('---------------------------updated---------------------------')
    },
    created() {
        // //console.log('---------------------------created---------------------------')
        localStorage.removeItem('favorite_plan_ids')
        localStorage.removeItem('favorite_plan_keys')
        
        this.batch_type = localStorage.getItem('batch_type') || ''
        
        let query = this.$route.query;
        
        this.batch_id = query.batch_id || '';
        this.province_id = localStorage.getItem('province_id') || 0
        this.application_form_id = this.$route.query.id
        
        let base_info = localStorage.getItem('base_info') || null
        if (base_info !== null && base_info !== 'null' && base_info !== '[]' && base_info !== '' && base_info !== 'undefined') {
            this.base_info = JSON.parse(base_info)
        }
        
        // this.system_tips()
        //this.get_report_info(1)
        this.get_examinees_application_info()
        this.get_user_param()
        
        let that = this
        $(window).scroll(function () {
            //获取滚动条的高度
            let scrollTop = $(this).scrollTop();
            //获取一个屏幕的高度
            let windowHeight = document.body.clientHeight;
            
            if ((document.body.clientHeight - scrollTop) < window.innerHeight * 2 && that.load_more === false) {
                that.load_more = true
                that.form.page += 1
                that.tableData = that.favorite_list.slice(0, that.form.page * that.form.page_size)
                that.load_more = false
            }
        });
        
        if (window.location.host.indexOf('teacher-login') > -1) {
            this.get_agent_info()
            this.teacher_login = true
        }
    },
    methods: {
        get_agent_info() {
            let local = new URL(window.location.href)
            let that = this
            axios.get(
                'https://oss.shudaozaixian.com/cache/agent_cms_info/list/' + local.hostname + '.json?time=' + new Date().getTime(), {}
            ).then(function (res) {
                if (res.data.domain) {
                    console.log('---agent_cms_info---')
                    if (res.data.open_set_value_rank !== undefined && res.data.open_set_value_rank !== null) {
                        if (res.data.open_set_value_rank > 0) {
                            that.teacher_login = true
                        }
                    }
                }
            }).catch(function (err) {
            });
        },
        handleClick() {
            alert("Hello World!"); // 这里是按钮点击后要执行的代码
        },
        show_guide() {
            let description = ""
            description += "<div style='display: flex;justify-content: space-around;align-items: center;'>"
            description += "<div style='display: flex;flex-direction:column;justify-content:center;align-items: center;margin-left: 10px;margin-top: 20px;margin-bottom: 20px;'>"
            description += "<a href='https://oss.shudaozaixian.com/report_pdf/13/607e80fe-e315-4c8f-9738-7fc302ffe5e0.pdf' target='_blank'>"
            description += "<img src='https://oss.shudaozaixian.com/agent_reoprt/0/baogao_fengmian.png' style='margin-left: 5px;height: 200px; width: 150px;' />"
            description += "</a>"
            description += "</div>"
            description += "<div style='width: 200px;margin-left:20px;margin-right: 10px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;'>"
            description += "<div>为了您志愿方案的安全、科学，别忘了提交志愿方案审核！</div>"
            description += "<div style='margin-left:-10px;color: #b88230;background-color: #f4f4f5;padding: 2px 5px;border: 1px solid #f4f4f5;border-radius: 2px;cursor: pointer;margin-top: 20px;width: 100px;text-align: center;'>"
            description += "<a href='https://oss.shudaozaixian.com/report_pdf/13/607e80fe-e315-4c8f-9738-7fc302ffe5e0.pdf' target='_blank' style='text-decoration: none;color: #b88230;'>查看报告样本</a>"
            description += "</div>"
            description += "</div>"
            description += "</div>"
            
            const driverObj = driver({
                showButtons: ['close'],
                animate: false,
                showProgress: false,
                steps: [
                    {
                        element: '#submit_report_view',
                        popover: {
                            title: '',
                            description: description,
                            side: "left",
                            align: "start"
                        }
                    },
                ]
            });
            driverObj.drive();
        },
        show_report_popover_body_click() {
            this.show_report_popover = false
        },
        show_default_report(e) {
            e.stopPropagation()
            window.open('https://oss.shudaozaixian.com/report_pdf/13/607e80fe-e315-4c8f-9738-7fc302ffe5e0.pdf', '_target')
        },
        get_user_param() {
            let that = this
            axios.get(
                api.user.search_param, {}
            ).then(function (res) {
                if (res.data.code === 10000) {
                    localStorage.setItem('get_user_param', JSON.stringify(res.data.data))
                }
            }).catch(function (err) {
            });
        },
        changeTab(val) {
            if (this.tab === val) return;
            if (this.batch_type !== 'major_class') {
                for (let i in this.favorite_list) {
                    this.favorite_list[i]['show_more'] = false
                }
            }
            this.tab = val;
        },
        canot_change_favorites() {
            ElNotification({
                title: '提醒',
                message: '该志愿表与您的当前分数或选科信息不匹配！',
                type: 'warning',
            })
        },
        show_major_detail(major_name, major_code) {
            let page = this.$router.resolve({
                path: '/tools',
                query: {type: 'zhuanye', major_code: major_code, major_name: major_name}
            })
            window.open(page.href, '_blank')
        },
        majors_job_info_close() {
            this.show_majors_job_info = !this.show_majors_job_info
            this.majors_job_info = []
            this.majors_job_list = []
        },
        buy_submit_times() {
            this.$router.push({
                path: '/buy_report_times',
                query: {batch_id: this.batch_id, id: this.application_form_id}
            })
        },
        submit_report_fun() {
            this.show_buy_submit_status = false
            this.show_submit_status = false
            this.save_favorites(null, true)
        },
        cancel_report_fun() {
        },
        handleScroll(e) {
            // //console.log(e)
        },
        get_oss_list() {
            let that = this
            axios.get(
                api.oss.list + '?t=' + (Date.now() + ''), {}
            ).then(function (res) {
                that.oss_list_url = res.data
                
                let teacher_login = localStorage.getItem('teacher_login') || 0
                if (parseInt(teacher_login) !== 1) {
                    that.get_agent_power()
                } else {
                    that.get_report_info(1)
                }
            }).catch(function (err) {
            });
        },
        get_sheng_oss_list() {
            let that = this
            // //console.log('-------------this.batch_id--------------')
            // //console.log(this.batch_id)
            let url = api.oss.sheng_list.replace('placeholder', this.province_id) + '?t=' + (Date.now() + '')
            axios.get(
                url, {}
            ).then(function (res) {
                that.oss_sheng_list = res.data
                let gailv_url = that.oss_sheng_list.province_score_gailv.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
                let chongwenbao_url = that.oss_sheng_list.province_score_chongwenbao.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
                let toudang_gailv_url = that.oss_sheng_list.province_score_toudang_gailv.replace('placeholder', that.province_id + '/' + that.base_info.class_id + '/' + that.batch_id + '/' + that.base_info.score)
                
                // //console.log(gailv_url)
                // //console.log(chongwenbao_url)
                // //console.log(toudang_gailv_url)
                
                axios.all(
                    [axios.get(gailv_url), axios.get(chongwenbao_url), axios.get(toudang_gailv_url)]
                ).then(
                    axios.spread((gailv_Res, chongwenbao_Res, toudang_gailv_Res) => {
                        that.province_score_gailv = gailv_Res.data
                        localStorage.setItem('province_score_gailv', JSON.stringify(gailv_Res.data))
                        
                        that.province_score_chongwenbao = chongwenbao_Res.data
                        localStorage.setItem('province_score_chongwenbao', JSON.stringify(chongwenbao_Res.data))
                        
                        that.province_score_toudang_gailv = toudang_gailv_Res.data
                        localStorage.setItem('province_score_toudang_gailv', JSON.stringify(toudang_gailv_Res.data))
                        
                        that.favorites()
                    })
                )
            }).catch(function (err) {
            });
        },
        del_gailv(list, gailv, qujian) {
            this.gailv = parseFloat(this.gailv)
            gailv = parseFloat(gailv)
            let score = parseFloat(list.forecast_low_score)
            
            if (score > parseFloat(qujian['c'])) {//高冲
                let min = parseFloat(qujian['g_min'])
                let max = parseFloat(qujian['g_max'])
                this.gc_all_gailv -= gailv
                if (this.gc_all_gailv <= min) {
                    this.gc_all_gailv = 0
                    this.gc_gailv = this.gc_all_gailv
                } else if (this.gc_all_gailv >= max) {
                    this.gc_gailv = max
                } else {
                    this.gc_gailv = this.gc_all_gailv
                }
            } else if (score > parseFloat(qujian['w'])) {//冲
                let min = parseFloat(qujian['c_min'])
                let max = parseFloat(qujian['c_max'])
                this.c_all_gailv -= gailv
                if (this.c_all_gailv <= min) {
                    this.c_all_gailv = 0
                    this.c_gailv = this.c_all_gailv
                } else if (this.c_all_gailv >= max) {
                    this.c_gailv = max
                } else {
                    this.c_gailv = this.c_all_gailv
                }
            } else if (score > qujian['b']) {//稳
                let min = parseFloat(qujian['w_min'])
                let max = parseFloat(qujian['w_max'])
                this.w_all_gailv -= gailv
                if (this.w_all_gailv <= min) {
                    this.w_all_gailv = 0
                    this.w_gailv = this.w_all_gailv
                } else if (this.w_all_gailv >= max) {
                    this.w_gailv = max
                } else {
                    this.w_gailv = this.w_all_gailv
                }
                
            } else if (score > qujian['d']) {//保
                let min = parseFloat(qujian['b_min'])
                let max = parseFloat(qujian['b_max'])
                this.b_all_gailv -= gailv
                if (this.b_all_gailv <= min) {
                    this.b_all_gailv = 0
                    this.b_gailv = this.b_all_gailv
                } else if (this.b_all_gailv >= max) {
                    this.b_gailv = max
                } else {
                    this.b_gailv = this.b_all_gailv
                }
            } else {//低保
                let min = parseFloat(qujian['d_min'])
                let max = parseFloat(qujian['d_max'])
                this.db_all_gailv -= gailv
                if (this.db_all_gailv <= min) {
                    this.db_all_gailv = 0
                    this.db_gailv = this.db_all_gailv
                } else if (this.db_all_gailv >= max) {
                    this.db_gailv = max
                } else {
                    this.db_gailv = this.db_all_gailv
                }
            }
            
            this.gc_gailv = parseFloat(this.gc_gailv)
            this.c_gailv = parseFloat(this.c_gailv)
            this.w_gailv = parseFloat(this.w_gailv)
            this.b_gailv = parseFloat(this.b_gailv)
            this.db_gailv = parseFloat(this.db_gailv)
            
            this.all_gailv = (this.gc_all_gailv + this.c_all_gailv + this.w_all_gailv + this.b_all_gailv + this.db_all_gailv)
            this.gailv = (this.gc_gailv + this.c_gailv + this.w_gailv + this.b_gailv + this.db_gailv)
            if (this.gailv > 99) {
                this.gailv = 99.00
            } else if (this.gailv < 0) {
                this.gailv = 0
            }
            
            this.gailv = this.gailv.toFixed(1)
        },
        set_gailv(list, gailv, qujian) {
            this.gailv = parseFloat(this.gailv)
            gailv = parseFloat(gailv)
            let score = parseFloat(list.forecast_low_score)
            
            if (score > parseFloat(qujian['c'])) {//高冲
                let min = parseFloat(qujian['g_min'])
                let max = parseFloat(qujian['g_max'])
                if (this.gc_all_gailv === 0) {
                    this.gc_all_gailv = min + gailv
                } else {
                    this.gc_all_gailv += gailv
                }
                if (this.gc_all_gailv > max) {
                    this.gc_gailv = max
                } else {
                    this.gc_gailv = this.gc_all_gailv
                }
                this.gao_chong += 1
            } else if (score > parseFloat(qujian['w'])) {//冲
                let min = parseFloat(qujian['c_min'])
                let max = parseFloat(qujian['c_max'])
                if (this.c_all_gailv === 0) {
                    this.c_all_gailv = min + gailv
                } else {
                    this.c_all_gailv += gailv
                }
                if (this.c_all_gailv > max) {
                    this.c_gailv = max
                } else {
                    this.c_gailv = this.c_all_gailv
                }
                this.impulse += 1
                
                // //console.log('===============================')
                // //console.log(min)
                // //console.log(max)
                // //console.log(this.c_all_gailv)
                // //console.log(this.c_gailv)
                
            } else if (score > qujian['b']) {//稳
                let min = parseFloat(qujian['w_min'])
                let max = parseFloat(qujian['w_max'])
                if (this.w_all_gailv === 0) {
                    this.w_all_gailv = min + gailv
                } else {
                    this.w_all_gailv += gailv
                }
                if (this.w_all_gailv > max) {
                    this.w_gailv = max
                } else {
                    this.w_gailv = this.w_all_gailv
                }
                this.stability += 1
            } else if (score > qujian['d']) {//保
                let min = parseFloat(qujian['b_min'])
                let max = parseFloat(qujian['b_max'])
                if (this.b_all_gailv === 0) {
                    this.b_all_gailv = min + gailv
                } else {
                    this.b_all_gailv += gailv
                }
                if (this.b_all_gailv > max) {
                    this.b_gailv = max
                } else {
                    this.b_gailv = this.b_all_gailv
                }
                this.guarantee += 1
            } else {//低保
                let min = parseFloat(qujian['d_min'])
                let max = parseFloat(qujian['d_max'])
                if (this.db_all_gailv === 0) {
                    this.db_all_gailv = min + gailv
                } else {
                    this.db_all_gailv += gailv
                }
                
                if (this.db_all_gailv > max) {
                    this.db_gailv = max
                } else {
                    this.db_gailv = this.db_all_gailv
                }
                this.di_bao += 1
            }
            this.gc_gailv = parseFloat(this.gc_gailv)
            this.c_gailv = parseFloat(this.c_gailv)
            this.w_gailv = parseFloat(this.w_gailv)
            this.b_gailv = parseFloat(this.b_gailv)
            this.db_gailv = parseFloat(this.db_gailv)
            this.gailv = parseFloat(this.gailv)
            
            // this.gc_gailv = this.gc_gailv.toFixed(1)
            // this.c_gailv = this.c_gailv.toFixed(1)
            // this.w_gailv = this.w_gailv.toFixed(1)
            // this.b_gailv = this.b_gailv.toFixed(1)
            // this.db_gailv = this.db_gailv.toFixed(1)
            
            
            this.all_gailv = (this.gc_all_gailv + this.c_all_gailv + this.w_all_gailv + this.b_all_gailv + this.db_all_gailv)
            this.gailv = (this.gc_gailv + this.c_gailv + this.w_gailv + this.b_gailv + this.db_gailv)
            if (this.gailv > 99) {
                this.gailv = 99.00
            }
            this.gailv = this.gailv.toFixed(1)
            // //console.log((this.gc_gailv + this.c_gailv + this.w_gailv + this.b_gailv + this.db_gailv))
        },
        get_agent_power() {
            let that = this
            let url = that.oss_list_url.agent_power.replace('placeholder', this.base_info.agent_id) + '?t=' + (Date.now() + '').substring(0, 9)
            axios.get(
                url, {}
            ).then(function (res) {
                that.user_power = res.data
                that.get_teacher_power()
            }).catch(function (err) {
                that.get_teacher_power()
            });
        },
        get_teacher_power() {
            let that = this
            let url = that.oss_list_url.teacher_power.replace('placeholder', this.base_info.teacher_id) + '?t=' + (Date.now() + '').substring(0, 9)
            axios.get(
                url, {}
            ).then(function (res) {
                that.user_power = res.data
                that.get_user_power()
            }).catch(function (err) {
                that.get_user_power()
            });
        },
        get_province_teacher_power() {
            let that = this
            let url = that.oss_list_url.teacher_power.replace('placeholder', this.base_info.private_teacher_id) + '?t=' + (Date.now() + '').substring(0, 9)
            axios.get(
                url, {}
            ).then(function (res) {
                that.user_power = res.data
                that.get_user_power()
            }).catch(function (err) {
                that.get_user_power()
            });
        },
        get_user_power() {
            let that = this
            let url = that.oss_list_url.user_power.replace('placeholder', this.base_info.base_user_id) + '?t=' + (Date.now() + '').substring(0, 9)
            axios.get(
                url, {}
            ).then(function (res) {
                that.user_power = res.data
                that.get_report_info(1)
            }).catch(function (err) {
                that.get_report_info(1)
            });
        },
        province_score_toudang_gailv_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_toudang_gailv.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_toudang_gailv = res.data
                localStorage.setItem('province_score_toudang_gailv', JSON.stringify(res.data))
            }).catch(function (err) {
                // //console.log(err)
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg
                });
            });
        },
        province_score_gailv_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_gailv.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_gailv = res.data
                localStorage.setItem('province_score_gailv', JSON.stringify(res.data))
            }).catch(function (err) {
                // //console.log(err)
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg
                });
            });
        },
        province_score_chongwenbao_json() {
            let that = this
            let url = that.oss_sheng_list.province_score_chongwenbao.replace('placeholder', this.province_id + '/' + this.base_info.class_id + '/' + this.batch_id + '/' + this.base_info.score)
            axios.get(
                url, {}
            ).then(function (res) {
                that.province_score_chongwenbao = res.data
                localStorage.setItem('province_score_chongwenbao', JSON.stringify(res.data))
            }).catch(function (err) {
                // //console.log(err)
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg
                });
            });
        },
        errorCollectionHandleClose() {
            this.upload_collection_status = false
        },
        open_report(id) {
            // //console.log(id)
            this.$router.push('/report?id=' + id)
        },
        remove_report(id) {
            this.remove_report_id = id
            this.remove_report_status = true
        },
        reportHandleClose() {
            this.cannel_remove_report();
        },
        cannel_remove_report() {
            this.remove_report_id = 0
            this.remove_report_status = false
        },
        look_report(pdf) {
            window.open(pdf)
        },
        handleClose() {
        },
        show_more() {
            this.show_more_info++
        },
        get_report_info(type = 2) {
            // user/
            let that = this
            axios.get(
                api.user.report_info, {params: {id: this.application_form_id}}
            ).then(function (res) {
                // //console.log(res)
                if (res.data.code === 10000) {
                    that.report_list = res.data.data
                    
                    if (that.report_list.length < 1 && type === 1 && that.examinees_application_info.batch_pre === 'ben' && that.user_power.submit_report == 1) {
                        //that.show_report_popover = true
                        that.show_guide()
                    }
                    if (that.report_num < 0) {
                        if (that.report_list.length < 1) {
                            clearInterval(that.timer);
                        } else {
                            let length = (that.report_list.length - 1)
                            if (that.report_list[length]['status'] > 1) {
                                clearInterval(that.timer);
                            }
                        }
                        
                        that.report_num = that.report_list.length
                    } else {
                        let length = (that.report_list.length - 1)
                        if (that.report_list[length]['status'] > 1) {
                            clearInterval(that.timer);
                        }
                    }
                }
            }).catch(function (err) {
            
            });
        },
        get_examinees_application_info() {
            // user/
            let that = this
            let obj = {
                ...this.form,
                batch_id: this.batch_id,
                application_form_id: this.application_form_id
            }
            axios.post(
                api.user.examinees_application_info, obj
            ).then(function (res) {
                // //console.log(res)
                if (res.data.code === 10000) {
                    that.examinees_application_info = res.data.data
                    that.batch_id = that.examinees_application_info.batch_id
                    that.batch_pre = that.examinees_application_info.batch_pre
                    that.batch_model = that.examinees_application_info.batch_model
                    that.batch_type = that.examinees_application_info.batch_model
                    
                    for (let i in that.base_info.subjects) {
                        if (that.examinees_application_info.subjects.indexOf(that.base_info.subjects[i]) < 0) {
                            that.can_change_plans = false
                            break
                        }
                    }
                    if (that.examinees_application_info.precedence != that.base_info.precedence) {
                        that.can_change_plans = false
                    }
                    that.get_sheng_oss_list()
                    that.get_oss_list()
                    
                }
            }).catch(function (err) {
                that.get_oss_list()()
            });
        },
        collect_sort_change() {
            let that = this
            axios.post(
                api.user.collect_sort_change, {collect_sort_type: this.collect_sort_type}
            ).then(function (res) {
                // //console.log(res)
            }).catch(function (err) {
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg,
                    offset: 50,
                });
            });
        },
        system_tips() {
            let that = this
            let data = http.get(api.system_tips.list, {
                page: 1,
                step: 10,
                show_all: 1
            })
            data.then(data => {
                // //console.log(data.data)
                that.system_tips_list = data.data
            })
        },
        submit_approval() {
            this.rank_status = true
        },
        replace_html(str) {
            return str.replace(/(<([^>]+)>)/ig, "");
        },
        upload_collection(type) {
            this.upload_collection_type = parseInt(type)
            document.querySelector("#file").click();
        },
        upload_file(event) {
            let inputDom = event.target
            let file = event.target.files[0];
            
            this.formData = new FormData();
            this.formData.append("file", file, file.name);
            
            let api_url = ''
            if (this.upload_collection_type === 1) {
                if (this.pre_form.batch === 'A') {
                    this.formData.append("batch_id", '1');
                } else {
                    this.formData.append("batch_id", '2');
                }
                api_url = this.preb_api
            } else if (this.upload_collection_type === 3) {
                api_url = this.vocation_api
            }
            
            let that = this;
            axios
                .post(api_url + api.user.upload_collection, this.formData)
                .then(function (res) {
                    // //console.log(res)
                    if (res.data.code === 10000) {
                        that.upload_collection_status = true
                        that.upload_collection_list = res.data.data
                        that.$notify({
                            title: '成功',
                            message: '信息录入成功',
                            type: 'success',
                            offset: 50,
                        });
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: res.data.data.msg,
                            offset: 50,
                        });
                    }
                    inputDom.value = ''
                    
                    that.favorites()
                })
                .catch(function (err) {
                    if (err.response) {
                        // //console.log(err.response.data);
                    } else {
                        // //console.log(err.message);
                    }
                    inputDom.value = ''
                });
        },
        tableRowClassName(info) {
            if (1 !== parseInt(info.row.result)) {
                return 'warning-row'
            }
            return ''
        },
        download_error_collection() {
            let that = this
            let result = [];
            result.push(['院校代号', '专业代号', '结果']);
            for (let i in that.upload_collection_list) {
                let data = [];
                if (parseInt(that.upload_collection_list[i]['result']) !== 1) {
                    data.push(that.upload_collection_list[i]['school_code'])
                    data.push(that.upload_collection_list[i]['major_num'])
                    data.push(that.upload_collection_list[i]['result_str'])
                    result.push(data);
                }
            }
            // //console.log('done...')
            let workbook = XLSX.utils.book_new();
            let ws1 = XLSX.utils.aoa_to_sheet(result);
            XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
            XLSX.writeFile(workbook, "导入收藏志愿-错误列表.xls"); //导出Excel
        },
        check_submit() {
            // this.show_buy_submit_status=true
            // return false
            if (this.base_info.submit_times > 5) {
                this.show_submit_status = true
            } else {
                // this.show_submit_status=true
                this.show_buy_submit_status = true
            }
        },
        download_collection_demo() {
            if (this.examinees_application_info.batch_model === "major_class") {
                this.download_collection_class_model()
            } else {
                this.download_collection_school_group()
            }
        },
        download_collection_class_model() {
            let title_str = this.examinees_application_info.name + ' ' + this.base_info.province_name + ' ' + this.base_info.name + ' ' + this.examinees_application_info.batch_name
                + ' ' + this.examinees_application_info.score + '分 ' + this.examinees_application_info.precedence + '位 ' + this.examinees_application_info.subjects
            
            let title = [
                title_str, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
            ]
            
            let history = this.tableData[0]['historical_data']
            let years = []
            for (let i in history) {
                let year = parseInt(i.replace('年', ''))
                years.push(year)
            }
            years.sort(function (a, b) {
                return b - a;
            });
            
            let now_year = this.base_info.year + '(招生计划)'
            
            let sub_title = [
                now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year,
                now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year,
                years[0], years[0], years[0], years[0], years[1], years[1], years[1], years[1], years[2], years[2], years[2], years[2]
            ]
            
            let list_title = [
                '序号', '院校代码', '院校', '层次', '保研率约', '地区/城市', '类型', '性质', '排名', '等效分', '专业录取概率', '专业代码', '专业', '专业实力', '计划', '学费', '学制', '选科',
                '录取人数', '线差', '最低分', '最低位次', '录取人数', '线差', '最低分', '最低位次', '录取人数', '线差', '最低分', '最低位次'
            ]
            
            let data = [title, sub_title, list_title];
            
            for (let i in this.favorite_list) {
                let label_list = ''
                if (this.favorite_list[i]['label_list'] !== undefined) {
                    label_list = this.favorite_list[i]['label_list'].join(' ')
                }
                
                let major_label = this.favorite_list[i]['discipline_ranking_major_str'] + ' ' + this.favorite_list[i]['postgraduate_major_str'] + ' ' + this.favorite_list[i]['doctor_major_str'] + ' ' + this.favorite_list[i]['first_class_major_str'] + ' ' + this.favorite_list[i]['nation_feature'] + ' ' + this.favorite_list[i]['double_first_class_level']
                
                let gailv = this.province_score_gailv[this.favorite_list[i]['forecast_low_score']] || ''
                
                let remarks = this.favorite_list[i]['remarks'] || ''
                remarks = remarks.replace(/<[^>]*>/g, '')
                
                let first_year = null
                let second_year = null
                let third_year = null
                
                for (let x in years) {
                    for (let j in this.favorite_list[i]['historical_data']) {
                        let year = parseInt(j.replace('年', ''))
                        if (years[x] === year) {
                            if (first_year === null) {
                                first_year = this.favorite_list[i]['historical_data'][j]
                                break
                            } else if (second_year === null) {
                                second_year = this.favorite_list[i]['historical_data'][j]
                                break
                            } else if (third_year === null) {
                                third_year = this.favorite_list[i]['historical_data'][j]
                                break
                            }
                        }
                    }
                }
                
                let baoyanlv = ''
                if (this.favorite_list[i]['school_guarantee_rate'] !== '') {
                    baoyanlv = this.favorite_list[i]['school_guarantee_rate']
                } else if (this.favorite_list[i]['postgraduate_str'] !== '') {
                    baoyanlv = this.favorite_list[i]['postgraduate_str']
                }
                if (baoyanlv === undefined || baoyanlv === null) {
                    baoyanlv = ''
                } else {
                    console.log(baoyanlv)
                    baoyanlv = baoyanlv.replace('保研率约', '')
                    baoyanlv = baoyanlv.replace('%', '')
                }
                
                let info = [
                    (parseInt(i) + 1),
                    this.favorite_list[i]['school_code'],
                    this.favorite_list[i]['school_name'],
                    label_list,
                    baoyanlv,//保研率
                    this.favorite_list[i]['address'],
                    this.favorite_list[i]['type_str'],
                    this.favorite_list[i]['nature_str'],
                    '校友会: ' + this.favorite_list[i]['xyh_sort'] + ' QS: ' + this.favorite_list[i]['qs_sort'] + ' 软科: ' + this.favorite_list[i]['ruanke_sort'],
                    this.favorite_list[i]['forecast_low_score'],
                    gailv + '%',
                    this.favorite_list[i]['major_num'],
                    this.favorite_list[i]['zhuanye_mingcheng'] + "\n" + remarks,
                    major_label,
                    this.favorite_list[i]['num'],
                    this.favorite_list[i]['fees'],
                    this.favorite_list[i]['length'],
                    this.favorite_list[i]['major_group_rule'],
                    first_year['number'] || '',
                    first_year['line_diff'] || '',
                    first_year['low_score'] || '',
                    first_year['precedence'] || '',
                    second_year['number'] || '',
                    second_year['line_diff'] || '',
                    second_year['low_score'] || '',
                    second_year['precedence'] || '',
                    third_year['number'] || '',
                    third_year['line_diff'] || '',
                    third_year['low_score'] || '',
                    third_year['precedence'] || '',
                ]
                data.push(info)
            }
            
            let wb = XLSX_JS.utils.book_new();
            let ws = XLSX_JS.utils.json_to_sheet(data, {skipHeader: true,});
            // s 表示要合并的单元格范围的左上角单元格，r 表示该单元格的行号，c 表示该单元格的列号，行列号从 0 开始计数。所以 { r: 0, c: 0 } 表示第 1 行第 1 列的单元格，即 A1 单元格。
            // e 表示要合并的单元格范围的右下角单元格，其含义与 s 相同。所以 { r: 0, c: 1 } 表示第 1 行第 2 列的单元格，即 B1 单元格。
            // 因此，{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } 表示要合并第 1 行第 1 列和第 1 行第 3 列之间的元格。
            // 注意，合并会以开始位置单元格中的内容为准，所以合并后的单元格中的内容为 A1 单元格中的内容。
            ws["!merges"] = [
                {s: {r: 0, c: 0}, e: {r: 0, c: 29}},
                {s: {r: 1, c: 0}, e: {r: 1, c: 17}}, {s: {r: 1, c: 18}, e: {r: 1, c: 21}}, {
                    s: {r: 1, c: 22},
                    e: {r: 1, c: 25}
                }, {s: {r: 1, c: 26}, e: {r: 1, c: 29}}
            ];
            ws["!cols"] = [
                {wch: 6}, {wch: 10}, {wch: 10}, {wch: 12}, {wch: 12}, {wch: 10}, {wch: 10}, {wch: 10}, {wch: 10},
                {wch: 8}, {wch: 10}, {wch: 10}, {wch: 6}, {wch: 8}, {wch: 15}, {wch: 10}, {wch: 5},
                {wch: 5}, {wch: 5}, {wch: 5}, {wch: 5}, {wch: 8}, {wch: 5}, {wch: 5}, {wch: 5}, {wch: 8},
                {wch: 5}, {wch: 5}, {wch: 5}, {wch: 8},
            ]
            
            let length = data.length
            let rows = [{hpx: 40}, {hpx: 30}, {hpx: 35}]
            for (let j = 1; j <= length; j++) {
                rows.push({hpx: 50})
            }
            ws["!rows"] = rows
            
            let column = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD'];
            for (let i in column) {
                for (let j = 1; j <= length; j++) {
                    let key = column[i] + '' + j
                    if (j < 3) {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 14,
                                bold: true,
                            },
                            alignment: {horizontal: "center", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    } else if (j === 3) {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 11,
                            },
                            alignment: {horizontal: "left", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    } else {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 11,
                                bold: false,
                            },
                            alignment: {horizontal: "left", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    }
                    
                }
            }
            
            XLSX_JS.utils.book_append_sheet(wb, ws, "收藏列表");
            XLSX_JS.writeFile(wb, "收藏列表.xlsx");
        },
        download_collection_school_group() {
            
            let title_str = this.examinees_application_info.name + ' ' + this.base_info.province_name + ' ' + this.base_info.name + ' ' + this.examinees_application_info.batch_name
                + ' ' + this.examinees_application_info.score + '分 ' + this.examinees_application_info.precedence + '位 ' + this.examinees_application_info.subjects
            
            let title = [title_str, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
            let history = this.tableData[0]['historical_data']
            let years = []
            for (let i in history) {
                let year = parseInt(i.replace('年', ''))
                years.push(year)
            }
            years.sort(function (a, b) {
                return b - a;
            });
            
            let now_year = this.base_info.year + '(招生计划)'
            let sub_title = [
                now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year,
                now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year, now_year,
                years[0], years[0], years[0], years[0], years[1], years[1], years[1], years[1], years[2], years[2], years[2], years[2]
            ]
            
            let list_title = [
                '组', '院校录取概率', '院校代码', '院校', '层次', '保研率约', '地区/城市', '类型', '性质', '排名', '选科', '等效分', '专业录取概率', '专业代码', '专业', '专业实力', '计划', '学费', '学制',
                '录取人数', '线差', '最低分', '最低位次', '录取人数', '线差', '最低分', '最低位次', '录取人数', '线差', '最低分', '最低位次'
            ]
            
            let data = [title, sub_title, list_title];
            
            // s 表示要合并的单元格范围的左上角单元格，r 表示该单元格的行号，c 表示该单元格的列号，行列号从 0 开始计数。所以 { r: 0, c: 0 } 表示第 1 行第 1 列的单元格，即 A1 单元格。
            // e 表示要合并的单元格范围的右下角单元格，其含义与 s 相同。所以 { r: 0, c: 1 } 表示第 1 行第 2 列的单元格，即 B1 单元格。
            // 因此，{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } 表示要合并第 1 行第 1 列和第 1 行第 3 列之间的元格。
            // 注意，合并会以开始位置单元格中的内容为准，所以合并后的单元格中的内容为 A1 单元格中的内容。
            let merges = [
                {s: {r: 0, c: 0}, e: {r: 0, c: 30}},
                {s: {r: 1, c: 0}, e: {r: 1, c: 18}},
                {s: {r: 1, c: 19}, e: {r: 1, c: 22}},
                {s: {r: 1, c: 23}, e: {r: 1, c: 26}},
                {s: {r: 1, c: 27}, e: {r: 1, c: 30}},
            ];
            
            let start = 3
            let end = 0
            
            
            for (let i in this.favorite_list) {
                for (let y in this.favorite_list[i]['sub_plan_ids']) {
                    let plan_info = this.favorite_list[i]['sub_plan_ids'][y]
                    if (plan_info['id'] === undefined) {
                        this.favorite_list[i]['sub_plan_ids'].splice(y, 1)
                    }
                }
            }
            
            for (let i in this.favorite_list) {
                for (let y in this.favorite_list[i]['sub_plan_ids']) {
                    let plan_info = this.favorite_list[i]['sub_plan_ids'][y]
                    let label_list = ''
                    if (plan_info['label_list'] !== undefined) {
                        label_list = plan_info['label_list'].join(' ')
                    }
                    
                    let major_label = plan_info['discipline_ranking_major_str'] + ' ' + plan_info['postgraduate_major_str'] + ' ' + plan_info['doctor_major_str'] + ' ' + plan_info['first_class_major_str'] + ' ' + plan_info['nation_feature'] + ' ' + plan_info['double_first_class_level']
                    
                    let gailv = this.province_score_gailv[plan_info['forecast_low_score']] || ''
                    
                    let remarks = plan_info['remarks'] || ''
                    remarks = remarks.replace(/<[^>]*>/g, '')
                    
                    let first_year = null
                    let second_year = null
                    let third_year = null
                    
                    let school_gailv = 0;
                    let school_name = plan_info['school_name']
                    if (this.examinees_application_info.batch_model === "major_group") {
                        if (plan_info['major_group_code'] !== '') {
                            school_name += plan_info['major_group_code'] + '组'
                        }
                        school_gailv = this.province_score_gailv[plan_info['group_forecast_low_score']] || ''
                    } else {
                        school_name += plan_info['danlie_biaoshi']
                        school_gailv = this.province_score_gailv[plan_info['school_forecast_low_score']] || ''
                    }
                    
                    for (let x in years) {
                        for (let j in plan_info['historical_data']) {
                            let year = parseInt(j.replace('年', ''))
                            if (years[x] === year) {
                                if (first_year === null) {
                                    first_year = plan_info['historical_data'][j]
                                    break
                                } else if (second_year === null) {
                                    second_year = plan_info['historical_data'][j]
                                    break
                                } else if (third_year === null) {
                                    third_year = plan_info['historical_data'][j]
                                    break
                                }
                            }
                        }
                    }
                    
                    let baoyanlv = ''
                    if (this.favorite_list[i]['school_guarantee_rate'] !== '') {
                        baoyanlv = this.favorite_list[i]['school_guarantee_rate']
                    } else if (this.favorite_list[i]['postgraduate_str'] !== '') {
                        baoyanlv = this.favorite_list[i]['postgraduate_str']
                    }
                    if (baoyanlv === undefined || baoyanlv === null) {
                        baoyanlv = ''
                    } else {
                        baoyanlv = baoyanlv.replace('保研率约', '')
                        baoyanlv = baoyanlv.replace('%', '')
                    }
                    
                    let first_year_number = ''
                    let first_year_line_diff = ''
                    let first_year_low_score = ''
                    let first_year_precedence = ''
                    if (first_year !== undefined && first_year !== null) {
                        first_year_number = first_year['number']
                        first_year_line_diff = first_year['line_diff']
                        first_year_low_score = first_year['low_score']
                        first_year_precedence = first_year['precedence']
                    }
                    
                    let second_year_number = ''
                    let second_year_line_diff = ''
                    let second_year_low_score = ''
                    let second_year_precedence = ''
                    if (second_year !== undefined && second_year !== null) {
                        second_year_number = second_year['number']
                        second_year_line_diff = second_year['line_diff']
                        second_year_low_score = second_year['low_score']
                        second_year_precedence = second_year['precedence']
                    }
                    
                    let third_year_number = ''
                    let third_year_line_diff = ''
                    let third_year_low_score = ''
                    let third_year_precedence = ''
                    if (third_year !== undefined && third_year !== null) {
                        third_year_number = third_year['number']
                        third_year_line_diff = third_year['line_diff']
                        third_year_low_score = third_year['low_score']
                        third_year_precedence = third_year['precedence']
                    }
                    
                    let info = [
                        parseInt(i) + 1,
                        school_gailv + '%',
                        plan_info['school_code'],
                        school_name,
                        label_list,
                        baoyanlv,
                        plan_info['address'],
                        plan_info['type_str'],
                        plan_info['nature_str'],
                        '校友会: ' + plan_info['xyh_sort'] + ' QS: ' + plan_info['qs_sort'] + ' 软科: ' + plan_info['ruanke_sort'],
                        plan_info['major_group_rule'],
                        plan_info['forecast_low_score'],
                        gailv + '%',
                        plan_info['major_num'],
                        plan_info['zhuanye_mingcheng'] + "\n" + remarks,
                        major_label,
                        plan_info['num'],
                        plan_info['fees'],
                        plan_info['length'],
                        first_year_number,
                        first_year_line_diff,
                        first_year_low_score,
                        first_year_precedence,
                        second_year_number,
                        second_year_line_diff,
                        second_year_low_score,
                        second_year_precedence,
                        third_year_number,
                        third_year_line_diff,
                        third_year_low_score,
                        third_year_precedence,
                    ]
                    
                    data.push(info)
                }
                let sub_length = this.favorite_list[i]['sub_plan_ids'].length
                if (sub_length > 1) {
                    end = start + sub_length - 1
                    merges.push({s: {r: start, c: 0}, e: {r: end, c: 0}})
                    merges.push({s: {r: start, c: 1}, e: {r: end, c: 1}})
                    merges.push({s: {r: start, c: 2}, e: {r: end, c: 2}})
                    merges.push({s: {r: start, c: 3}, e: {r: end, c: 3}})
                    merges.push({s: {r: start, c: 4}, e: {r: end, c: 4}})
                    merges.push({s: {r: start, c: 5}, e: {r: end, c: 5}})
                    merges.push({s: {r: start, c: 6}, e: {r: end, c: 6}})
                    merges.push({s: {r: start, c: 7}, e: {r: end, c: 7}})
                    merges.push({s: {r: start, c: 8}, e: {r: end, c: 8}})
                    merges.push({s: {r: start, c: 9}, e: {r: end, c: 9}})
                }
                
                start += sub_length
            }
            
            let wb = XLSX_JS.utils.book_new();
            let ws = XLSX_JS.utils.json_to_sheet(data, {skipHeader: true,});
            
            ws["!merges"] = merges
            ws["!cols"] = [
                {wch: 8}, {wch: 10}, {wch: 10}, {wch: 12}, {wch: 12}, {wch: 10}, {wch: 10}, {wch: 10}, {wch: 10}, {wch: 12}, {wch: 10},
                {wch: 10}, {wch: 10}, {wch: 10}, {wch: 15}, {wch: 10}, {wch: 5}, {wch: 5}, {wch: 5}, {wch: 8}, {wch: 5},
                {wch: 5}, {wch: 7}, {wch: 8}, {wch: 5}, {wch: 5}, {wch: 7}, {wch: 8}, {wch: 5}, {wch: 5}, {wch: 7},
            ]
            
            let length = data.length
            let rows = [{hpx: 40}, {hpx: 30}, {hpx: 35}]
            for (let j = 1; j <= length; j++) {
                rows.push({hpx: 50})
            }
            ws["!rows"] = rows
            
            let column = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE'];
            
            for (let i in column) {
                for (let j = 1; j <= length; j++) {
                    let key = column[i] + '' + j
                    if (j < 3) {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 14,
                                bold: true,
                            },
                            alignment: {horizontal: "center", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    } else if (j === 3) {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 11,
                            },
                            alignment: {horizontal: "center", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    } else {
                        ws[key].s = {
                            font: {
                                name: "宋体",
                                sz: 11,
                                bold: false,
                            },
                            alignment: {horizontal: "center", vertical: "center", wrapText: true},
                            border: {
                                top: {style: 'thin', color: 'FFFFAA00'},
                                bottom: {style: 'thin', color: 'FFFFAA00'},
                                left: {style: 'thin', color: 'FFFFAA00'},
                                right: {style: 'thin', color: 'FFFFAA00'},
                            }
                        }
                    }
                    
                }
            }
            
            XLSX_JS.utils.book_append_sheet(wb, ws, "收藏列表");
            XLSX_JS.writeFile(wb, "收藏列表.xlsx");
        },
        download_collection() {
            let that = this
            this.form.page = 1;
            this.form.page_size = 300;
            let obj = {
                ...this.form,
                batch_id: this.batch_id,
                application_form_id: this.application_form_id,
            }
            axios.post(
                api.user.favorites, obj
            ).then(function (res) {
                // //console.log(res)
                if (res.data.code === 10000) {
                    let list = res.data.data.data
                    // //console.log(list)
                    let result = [];
                    if (that.form.order_type == 2) { // 推荐排序
                        result.push(['院校代号', '院校名称', '专业代号', '专业名称', '预测类型', '院校性质', '院校类型', '院校标签', '专业标签', '等效分', '招生人数', '学年', '学费', '备注']);
                    } else {
                        result.push(['院校代号', '院校名称', '专业代号', '专业名称', '预测类型', '院校性质', '院校类型', '院校标签', '等效分', '招生人数', '学年', '学费', '备注']);
                    }
                    for (let i in list) {
                        let label_list = ''
                        if (list[i]['label_list'] !== undefined && list[i]['label_list'].length > 0) {
                            label_list = list[i]['label_list'].join(',  ')
                        }
                        
                        let major_label = [];
                        if (list[i]['postgraduate_major_str'].length > 0) {
                            major_label.push(list[i]['postgraduate_major_str'])
                        }
                        if (list[i]['doctor_major_str'].length > 0) {
                            major_label.push(list[i]['doctor_major_str'])
                        }
                        if (list[i]['discipline_ranking_major_str'].length > 0) {
                            major_label.push(list[i]['discipline_ranking_major_str'])
                        }
                        if (list[i]['first_class_major_str'].length > 0) {
                            major_label.push(list[i]['first_class_major_str'])
                        }
                        
                        let data = [];
                        data.push((list[i]['school_code'] || '') + "\t")
                        data.push(list[i]['school_name'])
                        data.push((list[i]['major_num'] || '') + "\t")
                        data.push(list[i]['majors_name'])
                        data.push(list[i]['match_str'])
                        data.push(list[i]['nature_str'])
                        data.push(list[i]['type_str'])
                        data.push(label_list)
                        if (that.form.order_type == 2) {
                            data.push(major_label.join(',  '))
                        }
                        data.push(list[i]['forecast_low_score'])
                        data.push(list[i]['num'])
                        data.push(list[i]['length'] || '')
                        data.push(list[i]['fees'])
                        data.push(that.replace_html(list[i]['remarks']))
                        result.push(data);
                    }
                    // //console.log('done...')
                    
                    let workbook = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.aoa_to_sheet(result);
                    XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
                    XLSX.writeFile(workbook, "我收藏的志愿.xls"); //导出Excel
                }
            }).catch(function (err) {
                // //console.log(err)
                that.$notify.error({
                    title: '错误',
                    message: '请求错误 请稍后再试',
                    offset: 50,
                });
            });
        },
        approval_report() {
            if (this.favorite_list.length === 0) {
                ElMessageBox.alert('请到选志愿板块，选择志愿', '提醒', {
                    confirmButtonText: '好的',
                    callback: () => {
                    },
                })
                return false
            }
            
            let that = this
            clearInterval(that.timer);
            that.timer = null
            that.report_num = -1
            axios.get(
                api.user.send_report, {params: {id: this.application_form_id}}
            ).then(function (res) {
                // //console.log(res)
                // //console.log(res.data.code)
                if (res.data.code === 10000) {
                    that.base_info.submit_times--
                    ElNotification({
                        title: '操作成功',
                        message: '您选择的志愿已经提交审核',
                        duration: 3000,
                        offset: 50,
                    })
                    that.get_user_info()
                    that.timer = setInterval(function () {
                        that.get_report_info()
                    }, 2000);
                } else {
                    ElNotification({
                        title: '操作失败',
                        message: res.data.data.join(''),
                        duration: 0,
                        offset: 50,
                    })
                }
            }).catch(function (err) {
                that.$notify.error({
                    title: '错误',
                    message: err.response.data.msg,
                    offset: 50,
                });
            });
        },
        get_user_info() {
            let that = this
            axios.post(api.user.info, {}).then(function (res) {
                localStorage.setItem('base_info', JSON.stringify(res.data.data))
            }).catch(function (err) {
            });
        },
        school_info(school_id, school_name, from = 1) {
            let page = this.$router.resolve({
                path: '/school_info',
                query: {
                    school_id: school_id,
                    school_name: school_name,
                    from: from,
                    batch: this.batch_id
                }
            })
            
            window.open(page.href, '_blank')
        },
        school_map(school_name) {
            const routeData = this.$router.resolve({path: '/school_map', query: {school_name: school_name}})
            window.open(routeData.href, '_blank')
        },
        open_vip() {
            let _this = this
            _this.$router.push('/goods')
        },
        collection_order_click(e) {
            this.form.order_type = 1
            this.tableData = []
            this.form.page = 1;
            this.favorites()
        },
        show_recommend() {
            this.remind_status = true
        },
        score_rank_change(e) {
            this.form.score_rank = parseInt(e)
            this.form.order_type = 2
            this.tableData = []
            this.form.page = 1;
            if (this.recommend_ranking === false) {
                this.remind_status = true
            }
            this.favorites()
        },
        handleSizeChange(val) {
            this.form.page_size = val
            this.form.page = 1
            this.setTableData()
        },
        handleCurrentChange(val) {
            this.form.page = val
            this.setTableData()
        },
        setTableData() {
            let that = this
            this.tableData = []
            
            this.select_rank = []
            
            for (let i in this.favorite_list) {
                this.favorite_list[i]['user_score_rank'] = (parseInt(i) + 1)
                this.favorite_list[i]['user_rank'] = (parseInt(i) + 1)
                
                this.select_rank.push((parseInt(i) + 1))
            }
            
            this.tableData = this.favorite_list.slice(0, this.form.page * this.form.page_size)
        },
        setSubTableData(danlie_group_key) {
            this.sub_select_rank = []
            for (let i in this.subTableData) {
                this.subTableData[i]['user_score_rank'] = (parseInt(i) + 1)
                this.subTableData[i]['user_rank'] = (parseInt(i) + 1)
                
                this.sub_select_rank[i] = (parseInt(i) + 1)
            }
            this.sub_favorite_list[danlie_group_key] = this.subTableData
            
            for (let i in this.favorite_list) {
                if (this.favorite_list[i]['danlie_group_key'] == danlie_group_key) {
                    this.favorite_list[i]['sub_plan_ids'] = this.subTableData
                }
            }
        },
        mod_favorites() {
            let batch_id = this.examinees_application_info.batch_id
            let batch_pre = this.examinees_application_info.batch_pre
            let batch_type = this.examinees_application_info.batch_model
            let batch_name = ''
            
            let province_zhanshi_fangshi = localStorage.getItem('province_zhanshi_fangshi')
            province_zhanshi_fangshi = JSON.parse(province_zhanshi_fangshi)
            for (let i in province_zhanshi_fangshi) {
                if (province_zhanshi_fangshi[i]['batch_id'] == batch_id) {
                    batch_name = province_zhanshi_fangshi[i]['batch_name']
                    break
                }
            }
            
            let plan_ids = []
            let plan_key = []
            for (let i in this.favorite_list) {
                plan_key.push(this.favorite_list[i]['danlie_group_key'])
                if (this.batch_type === 'major_class') {
                    plan_ids.push(this.favorite_list[i]['plan_id'])
                }
                if (this.favorite_list[i]['sub_plan_ids'] !== undefined && this.favorite_list[i]['sub_plan_ids'].length > 0) {
                    for (let j in this.favorite_list[i]['sub_plan_ids']) {
                        let plan_id = this.favorite_list[i]['sub_plan_ids'][j]['p'] || this.favorite_list[i]['sub_plan_ids'][j]['id']
                        if (plan_ids.indexOf(plan_id) < 0) {
                            plan_ids.push(plan_id)
                        }
                    }
                }
            }
            
            console.log(this.favorite_list)
            console.log(plan_ids)
            console.log(plan_key)
            
            localStorage.setItem('favorite_plan_ids', JSON.stringify(plan_ids))
            localStorage.setItem('favorite_plan_keys', JSON.stringify(plan_key))
            this.$router.push({
                path: '/chose_school',
                query: {batch: batch_id, type: batch_type, pre: batch_pre, name: batch_name}
            })
        },
        save_favorites(e, submit_report = false) {
            // //console.log(this.favorite_list)
            let that = this
            let plans = []
            
            for (let i in this.favorite_list) {
                let user_score_rank = this.favorite_list[i]['user_score_rank']
                let danlie_group_key = this.favorite_list[i]['danlie_group_key']
                for (let j in this.favorite_list[i]['sub_plan_ids']) {
                    let plan_id = this.favorite_list[i]['sub_plan_ids'][j]['plan_id'] || this.favorite_list[i]['sub_plan_ids'][j]['p']
                    let within_group_rank = this.favorite_list[i]['sub_plan_ids'][j]['user_score_rank']
                    if (within_group_rank === undefined) {
                        within_group_rank = this.favorite_list[i]['sub_plan_ids'][j]['s']
                    }
                    if (within_group_rank === undefined) {
                        within_group_rank = 0
                    }
                    plans.push({
                        'plan_id': plan_id,
                        'cwb': this.favorite_list[i]['sub_plan_ids'][j]['chongwenbao'] || this.favorite_list[i]['chongwenbao'],
                        'gl': this.favorite_list[i]['sub_plan_ids'][j]['toudang_gailv'] || this.favorite_list[i]['toudang_gailv'],
                        "user_score_rank": user_score_rank,
                        "within_group_rank": within_group_rank,
                        "danlie_group_key": danlie_group_key
                    })
                }
            }
            
            let data = http.post(api.user.save_change_favorites, {
                'application_id': this.examinees_application_info.id,
                'plan_ids': plans,
                'gailv': this.gailv
            })
            
            data.then(data => {
                // //console.log(data)
                if (data.code === 10000) {
                    //this.$router.go(0);
                    
                    if (submit_report === true) {
                        that.approval_report()
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '操作成功',
                            type: 'success',
                            offset: 50,
                        });
                    }
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: data.msg || '操作失败',
                        offset: 50,
                    });
                }
            })
        },
        un_favorite(info) {
            // console.log(info)
            let del_num = 0
            if (this.batch_type === 'major_class') {
                let plan_id = parseInt(info.list.plan_id)
                this.un_favorite_list.push(plan_id)
                
                let qujian = this.province_score_toudang_gailv['qujian']
                let gailv = parseFloat(this.province_score_toudang_gailv['score'][info.list.forecast_low_score])
                
                if (info.list.forecast_low_score > qujian['c']) {
                    this.gao_chong = this.gao_chong > 0 ? this.gao_chong - del_num : 0
                } else if (info.list.forecast_low_score > qujian['w']) {//稳
                    this.impulse = this.impulse > 0 ? this.impulse - del_num : 0
                } else if (info.list.forecast_low_score > qujian['b']) {//保
                    this.stability = this.stability > 0 ? this.stability - del_num : 0
                } else if (info.list.forecast_low_score > qujian['d']) {//低保
                    this.guarantee = this.guarantee > 0 ? this.guarantee - del_num : 0
                } else {
                    this.di_bao = this.di_bao > 0 ? this.di_bao - del_num : 0
                }
                
                for (let i in this.favorite_list) {
                    if (this.favorite_list[i]['plan_id'] == plan_id) {
                        del_num += 1
                        this.favorite_list.splice(i, 1)
                    }
                }
                this.setTableData()
                this.del_gailv({'forecast_low_score': info.list.forecast_low_score}, gailv, qujian)
                
                if (info.list.forecast_low_score > qujian['c']) {
                    this.gao_chong = this.gao_chong > 0 ? this.gao_chong - del_num : 0
                } else if (info.list.forecast_low_score > qujian['w']) {//稳
                    this.impulse = this.impulse > 0 ? this.impulse - del_num : 0
                } else if (info.list.forecast_low_score > qujian['b']) {//保
                    this.stability = this.stability > 0 ? this.stability - del_num : 0
                } else if (info.list.forecast_low_score > qujian['d']) {//低保
                    this.guarantee = this.guarantee > 0 ? this.guarantee - del_num : 0
                } else {
                    this.di_bao = this.di_bao > 0 ? this.di_bao - del_num : 0
                }
            } else {
                let qujian = this.province_score_toudang_gailv['qujian']
                let del_all = info.del_all || 0
                
                if (del_all > 0) {
                    let forecast_low_score = 0;
                    if (this.batch_type === 'major_group') {
                        forecast_low_score = info.list.group_forecast_low_score
                    } else {
                        forecast_low_score = info.list.school_forecast_low_score
                    }
                    let gailv = parseFloat(this.province_score_toudang_gailv['score'][forecast_low_score])
                    
                    this.del_gailv({'forecast_low_score': forecast_low_score}, gailv, qujian)
                    
                    for (let i in this.favorite_list) {
                        if (this.favorite_list[i]['danlie_group_key'] === info.list.danlie_group_key) {
                            del_num += 1
                            this.favorite_list.splice(i, 1)
                            this.setTableData()
                            break;
                        }
                    }
                    if (forecast_low_score > qujian['c']) {
                        this.gao_chong = this.gao_chong > 0 ? this.gao_chong - del_num : 0
                    } else if (forecast_low_score > qujian['w']) {//稳
                        this.impulse = this.impulse > 0 ? this.impulse - del_num : 0
                    } else if (forecast_low_score > qujian['b']) {//保
                        this.stability = this.stability > 0 ? this.stability - del_num : 0
                    } else if (forecast_low_score > qujian['d']) {//低保
                        this.guarantee = this.guarantee > 0 ? this.guarantee - del_num : 0
                    } else {
                        this.di_bao = this.di_bao > 0 ? this.di_bao - del_num : 0
                    }
                } else {
                    let forecast_low_score = 0;
                    let danlie_group_key = info.danlie_group_key || info.list.danlie_group_key
                    if (this.batch_type === 'major_group') {
                        forecast_low_score = info.group_forecast_low_score || info.forecast_low_score
                    } else {
                        forecast_low_score = info.school_forecast_low_score || info.forecast_low_score
                    }
                    
                    let gailv = parseFloat(this.province_score_toudang_gailv['score'][forecast_low_score])
                    let plan_id = info.plan_id || info.list.plan_id
                    
                    if (this.sub_favorite_list[danlie_group_key] !== undefined) {
                        for (let i in this.sub_favorite_list[danlie_group_key]) {
                            if (this.sub_favorite_list[danlie_group_key][i]['plan_id'] == plan_id) {
                                this.sub_favorite_list[danlie_group_key].splice(i, 1)
                                this.subTableData = this.sub_favorite_list[danlie_group_key]
                                break
                            }
                        }
                        
                        for (let i in this.sub_favorite_list[danlie_group_key]) {
                            this.sub_favorite_list[danlie_group_key][i]['user_score_rank'] = (parseInt(i) + 1)
                            this.sub_favorite_list[danlie_group_key][i]['within_group_rank'] = (parseInt(i) + 1)
                        }
                    }
                    
                    for (let i in this.favorite_list) {
                        if (this.favorite_list[i]['danlie_group_key'] === danlie_group_key) {
                            for (let j in this.favorite_list[i]['sub_plan_ids']) {
                                let _plan_id = this.favorite_list[i]['sub_plan_ids'][j]['id'] || this.favorite_list[i]['sub_plan_ids'][j]['p']
                                if (_plan_id == plan_id) {
                                    this.favorite_list[i]['sub_plan_ids'].splice(j, 1)
                                    //this.subTableData = this.favorite_list[i]['sub_plan_ids']
                                    //this.sub_favorite_list[danlie_group_key] = [...this.subTableData]
                                    this.setSubTableData(danlie_group_key)
                                    break
                                }
                            }
                            if (this.favorite_list[i]['sub_plan_ids'].length < 1) {
                                del_num += 1
                                this.del_gailv({'forecast_low_score': forecast_low_score}, gailv, qujian)
                                this.favorite_list.splice(i, 1)
                                this.setTableData()
                            }
                            break;
                        }
                    }
                    if (forecast_low_score > qujian['c']) {
                        this.gao_chong = this.gao_chong > 0 ? this.gao_chong - del_num : 0
                    } else if (forecast_low_score > qujian['w']) {//稳
                        this.impulse = this.impulse > 0 ? this.impulse - del_num : 0
                    } else if (forecast_low_score > qujian['b']) {//保
                        this.stability = this.stability > 0 ? this.stability - del_num : 0
                    } else if (forecast_low_score > qujian['d']) {//低保
                        this.guarantee = this.guarantee > 0 ? this.guarantee - del_num : 0
                    } else {
                        this.di_bao = this.di_bao > 0 ? this.di_bao - del_num : 0
                    }
                }
            }
        },
        chose_value_rank() {
            if(this.teacher_login || this.user_power.show_value_rank == 1 || this.user_power.show_value_rank === null || this.user_power.show_value_rank === undefined) {
                let that = this
                if (this.teacher_login) {
                    ElMessageBox.prompt('分数区间', '请输入价值排序的分数区间', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /^\d+$/,
                        inputValue: this.value_rank,
                        inputErrorMessage: '请输入大于0的整数',
                    }).then(({value}) => {
                        that.value_rank = parseInt(value)
                        that.collection_rank('tuijian')
                    }).catch(() => {
                    })
                } else {
                    that.collection_rank('tuijian')
                }
            }else{
                ElMessageBox.alert('价值排序为高阶功能。请联系发卡机构，在专业规划师的指导下使用！', '提醒', {
                    confirmButtonText: '好的',
                    callback: (action) => {
                    },
                })
            }
        },
        collection_rank(type) {
            // for (let i in this.favorite_list) {
            //     let school_guarantee_rate = this.favorite_list[i]['school_guarantee_rate']
            //     school_guarantee_rate = school_guarantee_rate.replace(' ', '')
            //     school_guarantee_rate = school_guarantee_rate.replace('保研率约', '')
            //     school_guarantee_rate = school_guarantee_rate.replace('%', '')
            //
            //     console.log(this.favorite_list[i]['score'])
            //     if(school_guarantee_rate.length > 0){
            //         this.favorite_list[i]['score'] += parseFloat(school_guarantee_rate) % 10
            //     }
            //     console.log(this.favorite_list[i]['score'])
            // }
            
            let that = this
            this.chose_rank = type
            let favorite_list = this.favorite_list
            this.tableData = []
            if (type === 'score') {
                favorite_list.sort(function (a, b) {
                    if (that.batch_type === 'school_strategy') {
                        if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                            return -1
                        }
                    } else if (that.batch_type === 'major_group') {
                        if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                            return -1
                        }
                    } else {
                        if (a.forecast_low_score >= b.forecast_low_score) {
                            return -1
                        }
                    }
                    return 1
                })
                favorite_list.sort(function (a, b) {
                    let a_score = 0
                    let b_score = 0
                    if (that.batch_type === 'school_strategy') {
                        a_score = a.school_forecast_low_score
                        b_score = b.school_forecast_low_score
                    } else if (that.batch_type === 'major_group') {
                        a_score = a.group_forecast_low_score
                        b_score = b.group_forecast_low_score
                    } else {
                        a_score = a.forecast_low_score
                        b_score = b.forecast_low_score
                    }
                    
                    if (parseInt(a_score) === parseInt(b_score)) {
                        if (a.score >= b.score) {
                            return -1
                        }
                        return 1
                        
                    }
                    return 1
                })
                
                for (let i in favorite_list) {
                    favorite_list[i]['sub_plan_ids'].sort(function (a, b) {
                        if (parseInt(a.forecast_low_score) >= parseInt(b.forecast_low_score)) {
                            return -1
                        }
                        return 1
                    })
                }
                
                for (let i in this.sub_favorite_list) {
                    this.sub_favorite_list[i].sort(function (a, b) {
                        if (parseInt(a.forecast_low_score) >= parseInt(b.forecast_low_score)) {
                            return -1
                        }
                        return 1
                    })
                }
            } else if (type === 'tuijian') {
                let _favorite_list = [...favorite_list]
                _favorite_list.sort(function (a, b) {
                    if (that.batch_type === 'school_strategy') {
                        if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                            return -1
                        }
                    } else if (that.batch_type === 'major_group') {
                        if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                            return -1
                        }
                    } else {
                        if (a.forecast_low_score >= b.forecast_low_score) {
                            return -1
                        }
                    }
                    return 1
                })
                
                let _all_list = []
                let _list = []
                let _score = 0
                
                for (let i in _favorite_list) {
                    let score = _favorite_list[i]['forecast_low_score']
                    if (that.batch_type === 'school_strategy') {
                        score = _favorite_list[i]['school_forecast_low_score']
                    } else if (that.batch_type === 'major_group') {
                        score = _favorite_list[i]['group_forecast_low_score']
                    } else {
                        score = _favorite_list[i]['forecast_low_score']
                    }
                    score = parseInt(score)
                    
                    if (_score === 0) {
                        _score = score
                        _list.push(_favorite_list[i])
                    } else {
                        if (_score - score >= this.value_rank) {
                            _list.sort(function (a, b) {
                                if (that.batch_type === 'school_strategy') {
                                    if (a.school_all_score >= b.school_all_score) {
                                        return -1
                                    }
                                } else if (that.batch_type === 'major_group') {
                                    if (a.group_all_score >= b.group_all_score) {
                                        return -1
                                    }
                                } else {
                                    if (parseFloat(a.score) === parseFloat(b.score)) {
                                        if (a.forecast_low_score > b.forecast_low_score) {
                                            return -1
                                        }
                                    } else {
                                        if (a.score > b.score) {
                                            return -1
                                        }
                                    }
                                }
                                return 1
                            })
                            _all_list = _all_list.concat(_list)
                            _list = [_favorite_list[i]]
                            _score = score
                        } else {
                            _list.push(_favorite_list[i])
                        }
                    }
                }
                
                _list.sort(function (a, b) {
                    if (that.batch_type === 'school_strategy') {
                        if (a.school_all_score >= b.school_all_score) {
                            return -1
                        }
                    } else if (that.batch_type === 'major_group') {
                        if (a.group_all_score >= b.group_all_score) {
                            return -1
                        }
                    } else {
                        if (parseFloat(a.score) === parseFloat(b.score)) {
                            if (a.forecast_low_score > b.forecast_low_score) {
                                return -1
                            }
                        } else {
                            if (a.score > b.score) {
                                return -1
                            }
                        }
                    }
                    return 1
                })
                
                _all_list = _all_list.concat(_list)
                favorite_list = _all_list
                
                for (let i in favorite_list) {
                    favorite_list[i]['sub_plan_ids'].sort(function (a, b) {
                        if (parseFloat(a.score) === parseFloat(b.score)) {
                            if (parseInt(a.forecast_low_score) > parseInt(b.forecast_low_score)) {
                                return -1
                            }
                        } else {
                            if (parseFloat(a.score) > parseFloat(b.score)) {
                                return -1
                            }
                        }
                        return 1
                    })
                }
                
                for (let i in this.sub_favorite_list) {
                    this.sub_favorite_list[i].sort(function (a, b) {
                        if (parseFloat(a.score) === parseFloat(b.score)) {
                            if (parseInt(a.forecast_low_score) > parseInt(b.forecast_low_score)) {
                                return -1
                            }
                        } else {
                            if (parseFloat(a.score) > parseFloat(b.score)) {
                                return -1
                            }
                        }
                        return 1
                    })
                }
            } else if (type === 'diqu') {
                favorite_list.sort(function (a, b) {
                    if (a.district_sort >= b.district_sort) {
                        return -1
                    }
                    return 1
                })
                favorite_list.sort(function (a, b) {
                    if (a.district_sort == b.district_sort) {
                        if (that.batch_type === 'school_strategy') {
                            if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else if (that.batch_type === 'major_group') {
                            if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else {
                            if (a.forecast_low_score >= b.forecast_low_score) {
                                return -1
                            }
                            return 1
                        }
                    }
                    return 1
                })
            } else if (type === 'xyh') {
                favorite_list.sort(function (a, b) {
                    if (a.xyh_sort < b.xyh_sort) {
                        return -1
                    }
                    return 1
                })
                favorite_list.sort(function (a, b) {
                    if (a.xyh_sort == b.xyh_sort) {
                        if (that.batch_type === 'school_strategy') {
                            if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else if (that.batch_type === 'major_group') {
                            if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else {
                            if (a.forecast_low_score >= b.forecast_low_score) {
                                return -1
                            }
                            return 1
                        }
                    }
                    return 1
                })
            } else if (type === 'ruanke') {
                favorite_list.sort(function (a, b) {
                    if (a.ruanke_sort < b.ruanke_sort) {
                        return -1
                    }
                    return 1
                })
                favorite_list.sort(function (a, b) {
                    if (a.ruanke_sort == b.ruanke_sort) {
                        if (that.batch_type === 'school_strategy') {
                            if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else if (that.batch_type === 'major_group') {
                            if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else {
                            if (a.forecast_low_score >= b.forecast_low_score) {
                                return -1
                            }
                            return 1
                        }
                    }
                    return 1
                })
            } else if (type === 'qs') {
                favorite_list.sort(function (a, b) {
                    if (a.qs_sort < b.qs_sort) {
                        return -1
                    }
                    return 1
                })
                favorite_list.sort(function (a, b) {
                    if (a.qs_sort == b.qs_sort) {
                        if (that.batch_type === 'school_strategy') {
                            if (a.school_forecast_low_score >= b.school_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else if (that.batch_type === 'major_group') {
                            if (a.group_forecast_low_score >= b.group_forecast_low_score) {
                                return -1
                            }
                            return 1
                        } else {
                            if (a.forecast_low_score >= b.forecast_low_score) {
                                return -1
                            }
                            return 1
                        }
                    }
                    return 1
                })
            } else {
                favorite_list.sort(function (a, b) {
                    if (a.favorite_id < b.favorite_id) {
                        return -1
                    }
                    return 1
                })
            }
            for (let i in favorite_list) {
                favorite_list[i]['user_score_rank'] = (parseInt(i) + 1)
                favorite_list[i]['user_rank'] = (parseInt(i) + 1)
            }
            this.favorite_list = favorite_list
            this.tableData = favorite_list.slice(0, 10)
        },
        show_detail(info) {
            for (let i in this.favorite_list) {
                this.favorite_list[i]['show_detail'] = false
                if (i == info.index) {
                    this.favorite_list[i]['show_detail'] = true
                }
            }
            if (info.show_detail === true) {
                this.favorite_list[info.index]['show_detail'] = false
            }
        },
        rank_change(info) {
            // console.log(typeof this.subTableData)
            // console.log(this.subTableData)
            this.chose_rank = ''
            let plan_info = info.info
            // console.log(info)
            if (info.type == 1) { // 组 单列 外循环
                let o_plan = this.favorite_list.splice((plan_info.user_rank - 1), 1)
                this.favorite_list.splice(parseInt(plan_info.user_score_rank - 1), 0, o_plan[0])
                for (let i in this.favorite_list) {
                    this.favorite_list[i]['user_score_rank'] = (parseInt(i) + 1)
                    this.favorite_list[i]['user_rank'] = (parseInt(i) + 1)
                }
                this.tableData = this.favorite_list.slice(0, 10)
            } else {
                
                let o_plan = this.subTableData.splice((plan_info.within_group_rank - 1), 1)
                // //console.log(plan_info.user_rank)
                // //console.log(plan_info.user_score_rank)
                // //console.log(o_plan)
                // //console.log(o_plan[0].user_rank)
                // //console.log(o_plan[0].user_score_rank)
                this.subTableData.splice(parseInt(plan_info.user_score_rank - 1), 0, o_plan[0])
                for (let i in this.subTableData) {
                    // //console.log(this.subTableData[i]['zhuanye_mingcheng'])
                    this.subTableData[i]['user_score_rank'] = (parseInt(i) + 1)
                    this.subTableData[i]['within_group_rank'] = (parseInt(i) + 1)
                    
                }
                this.sub_favorite_list[plan_info.danlie_group_key] = this.subTableData
                
                // //console.log('------info----------')
                // //console.log(plan_info)
                // //console.log(info)
                
                for (let i in this.favorite_list) {
                    if (this.favorite_list[i]['danlie_group_key'] == plan_info.danlie_group_key) {
                        // //console.log('----------ie_group_key] == info.danlie_-------------')
                        // //console.log(// //console.log(this.subTableData))
                        this.favorite_list[i]['sub_plan_ids'] = this.subTableData
                    }
                }
                
                // //console.log(this.favorite_list)
            }
        },
        show_majors_job(item) {
            let that = this
            
            this.show_majors_job_info = !this.show_majors_job_info
            this.majors_job_info = item
            
            // //console.log(item)
            let param = []
            for (let i in item) {
                param.push(item[i]['code'])
            }
            
            if (param.length < 1) {
                return false
            }
            axios.post(
                api.open_major.majors_info, {'major_codes': param}
            ).then(function (res) {
                // //console.log(res)
                if (res.data.code === 10000) {
                    // //console.log(res.data.data)
                    that.majors_job_list = res.data.data
                }
            }).catch(function (err) {
            });
        },
        no_match_major() {
            ElMessage({
                dangerouslyUseHTMLString: true,
                message: "<strong>选科不匹配</strong>",
                type: 'warning',
                offset: 40,
            })
        },
        sub_plans_list(obj, type = 0) {
            let index = obj.danlie_group_key
            if (type !== 1) {
                this.subTableData = [...this.sub_favorite_list[index]] || []
                this.sub_select_rank = []
                for (let i in this.subTableData) {
                    this.sub_select_rank.push(parseInt(i) + 1)
                }
                return false
            } else {
                if (this.sub_favorite_list[index] === undefined) {
                    this.sub_favorite_list[index] = []
                }
            }
            
            for (let i in this.favorite_list) {
                if (this.favorite_list[i]['danlie_group_key'] !== index) {
                    continue
                }
                let url_list = []
                for (let j in this.favorite_list[i]['sub_plan_ids']) {
                    let key = 'province_plans_' + this.batch_pre
                    let url = this.oss_sheng_list[key] || ''
                    url = url.replace('placeholder', this.province_id + '/' + this.batch_id + '/' + this.favorite_list[i]['sub_plan_ids'][j]['p'])
                    if (url === '') {
                        return false
                    }
                    url_list.push(axios.get(url))
                }
                axios.all(url_list).then(results => {
                    for (let j in results) {
                        let data = results[j]['data']
                        let _danlie_group_key = data['danlie_group_key']
                        if (this.sub_favorite_list[_danlie_group_key] === undefined) {
                            this.sub_favorite_list[_danlie_group_key] = []
                        }
                        for (let x in this.favorite_list) {
                            if (this.favorite_list[x]['danlie_group_key'] !== _danlie_group_key) {
                                continue
                            }
                            for (let y in this.favorite_list[x]['sub_plan_ids']) {
                                if (this.favorite_list[x]['sub_plan_ids'][y]['p'] == data['id']) {
                                    let _info = this.favorite_list[x]['sub_plan_ids'][y]
                                    
                                    data.favorite_value = 1
                                    data.collection = 1
                                    data.plan_id = data['id']
                                    data.user_score_rank = _info['s']
                                    data.user_rank = _info['r']
                                    data.within_group_rank = _info['s']
                                    data.toudang_gailv = (this.province_score_gailv[data.forecast_low_score] || '') + '%'
                                    data.chongwenbao = (this.province_score_chongwenbao[data.forecast_low_score] || '')
                                    
                                    this.sub_favorite_list[_danlie_group_key][y] = data
                                    this.favorite_list[x]['sub_plan_ids'][y] = data
                                    break
                                }
                            }
                        }
                    }
                })
            }
        },
        favorite(info) {
            // //console.log(info)
        },
        change(info = {}) {
            let obj = info.obj
            //let index = obj.school_id + '_' + obj.major_group_code + '_' + obj.danlie_biaoshi
            let index = obj.danlie_group_key
            
            this.subTableData = this.sub_favorite_list[index] || []
            
            for (let i in this.sub_favorite_list[index]) {
                if (this.sub_favorite_list[index][i]['id'] !== undefined) {
                    continue
                }
                let plan_id = this.sub_favorite_list[index][i]['plan_id']
                this.sub_favorite_list[index][i] = {...this.plan_info, ...this.sub_favorite_list[index][i]}
                
                let key = 'province_plans_' + this.batch_pre
                let url = this.oss_sheng_list[key] || ''
                url = url.replace('placeholder', this.province_id + '/' + this.batch_id + '/' + plan_id)
                if (url === '') {
                    return false
                }
                http.get(url, {}).then(data => {
                    for (let j in this.sub_favorite_list[index]) {
                        if (this.sub_favorite_list[index][j]['plan_id'] === data.id) {
                            this.sub_favorite_list[index][j] = {...data, ...this.sub_favorite_list[index][j]}
                            break
                        }
                    }
                    for (let j in this.subTableData) {
                        if (this.subTableData[j]['plan_id'] === data.id) {
                            this.subTableData[j] = [...data, ...this.subTableData[j]]
                            this.sub_favorite_list[index][j] = {...data, ...this.subTableData[j]}
                            break
                        }
                    }
                }).catch(data => {
                })
            }
        },
        favorites(type = '') {
            let that = this
            let obj = {
                ...this.form,
                batch_id: this.batch_id,
                application_form_id: this.application_form_id,
                show_type: type
            }
            let data = http.post(api.user.favorites, obj)
            data.then(data => {
                this.form.page = 1
                this.form.total = parseInt(data.data.length)
                this.form.page_size = 10
                this.form.show_more = 0
                this.collection_total = this.form.total
                
                this.favorite_list = []
                // console.log('------------data.data-----------------')
                for (let i in data.data) {
                    let info = data.data[i]
                    let key = info['k']
                    
                    let match = false
                    if (that.batch_type !== 'major_class') {
                        for (let j in this.favorite_list) {
                            if (this.favorite_list[j]['k'] == key) {
                                this.favorite_list[j]['list'].push(info)
                                match = true
                                break
                            }
                        }
                    }
                    if (match === false) {
                        info['list'] = [info]
                        this.favorite_list.push(info)
                    }
                }
                
                for (let i in this.favorite_list) {
                    this.select_rank.push((parseInt(i) + 1))
                }
                
                let url_list = []
                for (let i in this.favorite_list) {
                    let plan_id = this.favorite_list[i]['p']
                    let plan_info = {...this.plan_info}
                    
                    plan_info.collection = 1
                    plan_info.favorite_value = 1
                    plan_info.id = this.favorite_list[i]['p']
                    plan_info.plan_id = this.favorite_list[i]['p']
                    plan_info.user_score_rank = this.favorite_list[i]['r']
                    plan_info.user_rank = this.favorite_list[i]['r']
                    plan_info.within_group_rank = this.favorite_list[i]['s']
                    plan_info.list = this.favorite_list[i]['list']
                    
                    this.favorite_list[i] = plan_info
                    
                    let key = 'province_plans_' + this.batch_pre
                    let url = this.oss_sheng_list[key] || ''
                    url = url.replace('placeholder', this.province_id + '/' + this.batch_id + '/' + plan_id)
                    if (url === '') {
                        return false
                    }
                    if (parseInt(i) < 10) {
                        this.tableData[i] = this.favorite_list[i]
                    }
                    
                    url_list.push(axios.get(url))
                }
                
                axios.all(url_list).then(results => {
                    for (let j in results) {
                        let data = results[j]['data']
                        for (let j in this.favorite_list) {
                            if (this.favorite_list[j]['plan_id'] == data.id) {
                                if (data.sub_plan_ids) {
                                    data.sub_plan_ids_length = data.sub_plan_ids.length || 0
                                } else {
                                    data.sub_plan_ids_length = 0
                                }
                                
                                data.favorite_value = 1
                                data.collection = 1
                                data.show_more = false
                                data.plan_id = this.favorite_list[j]['plan_id']
                                data.user_score_rank = this.favorite_list[j]['user_score_rank']
                                data.user_rank = this.favorite_list[j]['user_rank']
                                data.within_group_rank = this.favorite_list[j]['within_group_rank']
                                data.sub_plan_ids = this.favorite_list[j]['list']
                                
                                // //console.log(data)
                                
                                if (this.batch_type === 'school_strategy') {
                                    data.toudang_gailv = (this.province_score_gailv[data['school_forecast_low_score']] || '') + '%'
                                    data.chongwenbao = (this.province_score_chongwenbao[data['school_forecast_low_score']] || '')
                                } else if (this.batch_type === 'major_group') {
                                    data.toudang_gailv = (this.province_score_gailv[data['group_forecast_low_score']] || '') + '%'
                                    data.chongwenbao = (this.province_score_chongwenbao[data['group_forecast_low_score']] || '')
                                } else {
                                    data.toudang_gailv = (this.province_score_gailv[data['forecast_low_score']] || '') + '%'
                                    data.chongwenbao = (this.province_score_chongwenbao[data['forecast_low_score']] || '')
                                }
                                
                                if (data.chongwenbao === '冲') {
                                    data.chongwenbao_url = 'https://oss.shudaozaixian.com/images/images/chong.png'
                                } else if (data.chongwenbao === '稳') {
                                    data.chongwenbao_url = 'https://oss.shudaozaixian.com/images/images/wen.png'
                                } else {
                                    data.chongwenbao_url = 'https://oss.shudaozaixian.com/images/images/bao.png'
                                }
                                
                                this.favorite_list[j] = data
                                if (this.batch_type !== 'major_class') {
                                    this.sub_plans_list({'danlie_group_key': data['danlie_group_key']}, 1)
                                }
                                
                                if (parseInt(j) < 10) {
                                    this.tableData[j] = data
                                }
                                
                                let qujian = that.province_score_toudang_gailv['qujian']
                                if (that.batch_type === 'school_strategy') {
                                    let gailv = parseFloat(this.province_score_toudang_gailv['score'][parseInt(data['school_forecast_low_score'])])
                                    that.set_gailv({'forecast_low_score': parseFloat(data['school_forecast_low_score'])}, gailv, qujian)
                                } else if (that.batch_type === 'major_group') {
                                    let gailv = parseFloat(this.province_score_toudang_gailv['score'][parseInt(data['group_forecast_low_score'])])
                                    that.set_gailv({'forecast_low_score': parseFloat(data['group_forecast_low_score'])}, gailv, qujian)
                                } else {
                                    let gailv = parseFloat(this.province_score_toudang_gailv['score'][parseInt(data['forecast_low_score'])])
                                    that.set_gailv({'forecast_low_score': parseFloat(data['forecast_low_score'])}, gailv, qujian)
                                }
                                break
                            }
                        }
                    }
                    that.loading = false
                }).catch((err) => {
                    that.loading = false
                    console.log(err)
                })
                
                if (this.tableData.length < 1) {
                    this.tableData_str = '去选择志愿'
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
* {
    font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    '微软雅黑', Arial, sans-serif;
}

:root {
    --el-color-primary: #FFFFFF;
    --el-color-primary-light-9: #E93A29;
    border: 0;
    
}

#top_con {
    position: sticky;
    top: 0px;
    background-color: #ffffff;
    z-index: 99;
    
}

.div_nav a {
    margin-left: 50px;
}

.box-card > > > .el-card__body {
    padding: 0;
}

.box-card > > > .el-card__header {
    padding: 0;
}

.school_tag > > > .el-tag--light {
    margin-left: 0px;
    margin-right: 5px;
}

.el-form-item > > > .el-form-item__label {
    line-height: 30px;
}

.el-form-item > > > .el-form-item__content {
    line-height: 30px;
    margin-left: 35px;
}

.home_page_container {
    background-color: white;
    width: 1230px;
    margin: 0 auto;
}

.div_nav a {
    margin-left: 50px;
}

.el-card > > > .el-card__header {
    padding: 0 20px;
}

.zhiyuanList {
    width: 1200px;
}

.upload-demo .el-button {
    padding: 0;
    margin: 0 auto;
    height: 30px;
    min-height: 30px;
    line-height: 30px;
    width: 120px;
    font-size: 14px;
}

.el-table .warning-row {
    --el-table-tr-bg-color: red;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #E93A29;
}

.el-table .warning-row {
    --el-table-tr-bg-color: red;
}

.chose_box {
    width: calc(100% - 20px);
    padding: 0;
    background: var(--sub-bg);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    
    .tabbar {
        width: 100%;
        height: 58px;
        display: flex;
        border-bottom: 1px solid var(--border);
        
        .bar,
        .onbar {
            width: 50%;
            height: 58px;
            line-height: 58px;
            text-align: center;
            font-size: 22px;
            color: var(--font-3);
            cursor: pointer;
        }
        
        .onbar {
            color: #fff;
            font-weight: 700;
            background: linear-gradient(94.31deg, #e93a29 0.73%, #ef6830 100%);
        }
    }
}

.plan_sort {
    display: flex;
    align-items: center;
    margin: 0 10px;
    cursor: pointer;
}

.plan_sort:hover {
    color: #ef6830;
}
</style>
